// Every string the site's own chrome shows, in each language it speaks. Keys are
// flat and dotted ("detail.share"); a missing key falls back to English.
import { FAQ_CATEGORY_BY_ID } from "@/data/faq";
import { viatorTitleLabel } from "@/lib/viator";

export const DEFAULT_LANG = "es";

export const LANGS = [
  { code: "es", label: "Español", short: "ES" },
  { code: "en", label: "English", short: "EN" },
];

// Browse categories keep their stored English names as filter values; this is
// only how a chip reads on screen.
const CATEGORY_LABELS = {
  es: {
    "Eat & Drink": "Comer y beber",
    Restaurants: "Restaurantes",
    Restaurant: "Restaurante",
    Bakery: "Panadería",
    Cafe: "Cafetería",
    Café: "Cafetería",
    Bar: "Bar",
    Shop: "Tienda",
    Experience: "Experiencia",
    Beach: "Playa",
    Service: "Servicio",
    Services: "Servicios",
    Museum: "Museo",
    Park: "Parque",
    Gallery: "Galería",
    Gym: "Gimnasio",
    Salon: "Salón",
    Nightlife: "Vida nocturna",
    Music: "Música",
    Comedy: "Comedia",
    Community: "Comunidad",
    Art: "Arte",
    "Cultural Place": "Lugar cultural",
    "Local Business": "Negocio local",
    "Spanish restaurant": "Restaurante español",
    Sushi: "Sushi",
    Pizza: "Pizza",
    Mexican: "Comida mexicana",
    BBQ: "Barbacoa",
    "Tapas bar": "Bar de tapas",
    Sandwiches: "Sándwiches",
    Vegetarian: "Comida vegetariana",
    "Fine dining": "Alta cocina",
    "Sports bar": "Bar deportivo",
    Nightclub: "Discoteca",
    "LGBTQ+ Bar": "Bar LGBTQ+",
    "LGBTQ+ Nightclub": "Discoteca LGBTQ+",
    "Live music": "Música en vivo",
    Bookstore: "Librería",
    "Botánica": "Botánica",
    Market: "Mercado",
    Mural: "Mural",
    Sculpture: "Escultura",
    Fort: "Fuerte",
    Church: "Iglesia",
    Distillery: "Destilería",
    Waterfront: "Zona costera",
    "Science park": "Parque científico",
    "Nature reserve": "Reserva natural",
    Arena: "Arena",
    Entertainment: "Entretenimiento",
    "Historic site": "Lugar histórico",
    Landmark: "Lugar emblemático",
    Place: "Lugar",
    "local business": "negocio local",
    "Local Shops": "Tiendas locales",
    "Local Services": "Servicios locales",
    "Tours & Adventures": "Recorridos y aventuras",
    Gastronomy: "Gastronomía",
    Culture: "Cultura",
    Experiences: "Experiencias",
    Beaches: "Playas",
    "LGBTQ+": "LGBTQ+",
    "Chinchorros & Kiosks": "Chinchorros y kioscos",
    "Comedores & Home-Style Cooking": "Comedores y cocina casera",
    "Puerto Rican Criollo": "Cocina criolla puertorriqueña",
    "Breakfast & Brunch": "Desayunos y brunch",
    "Cafés & Specialty Coffee": "Cafés y café de especialidad",
    "Bakeries & Pastries": "Panaderías y repostería",
    "Desserts & Ice Cream": "Postres y helados",
    "Juice Bars & Smoothies": "Jugos y batidas",
    "Sandwiches & Deli": "Sándwiches y delicatessen",
    "Tacos & Mexican": "Tacos y comida mexicana",
    "Sushi & Japanese": "Sushi y comida japonesa",
    "Caribbean & BBQ": "Comida caribeña y barbacoa",
    Seafood: "Mariscos",
    Steakhouse: "Restaurantes de carnes",
    "Spanish & Tapas": "Cocina española y tapas",
    "Vegan & Vegetarian": "Comida vegana y vegetariana",
    "Fine Dining": "Alta cocina",
    "Buffets & Family Style": "Buffets y comida familiar",
    "Rooftops & Views": "Azoteas y vistas",
    "Bars & Lounges": "Bares y lounges",
    "Cocktail Bars & Speakeasies": "Bares de cócteles y speakeasies",
    "Rooftop Bars": "Bares en azoteas",
    "Craft Breweries & Pubs": "Cervecerías artesanales y pubs",
    "Pubs & Sports Bars": "Pubs y bares deportivos",
    "Breweries & Taprooms": "Cervecerías y salas de degustación",
    "Wine Bars": "Bares de vinos",
    "Wine & Mezcal Bars": "Bares de vino y mezcal",
    Museums: "Museos",
    "Art Galleries": "Galerías de arte",
    "Historic Forts & Citadels": "Fuertes y ciudadelas históricas",
    "Historic Churches & Chapels": "Iglesias y capillas históricas",
    "Historic Sites & Monuments": "Lugares históricos y monumentos",
    "Plazas & Squares": "Plazas",
    "Parks & Gardens": "Parques y jardines",
    "Botanical Gardens": "Jardines botánicos",
    "Public Art & Murals": "Arte público y murales",
    "Architecture & Heritage": "Arquitectura y patrimonio",
    "Cultural Centers": "Centros culturales",
    "Theaters & Performance Venues": "Teatros y espacios de espectáculos",
    "Music Halls & Concert Venues": "Salas de música y conciertos",
    "Distilleries & Heritage Tours": "Destilerías y recorridos patrimoniales",
    "Libraries & Archives": "Bibliotecas y archivos",
    "Science & Educational Centers": "Centros científicos y educativos",
    "Neighborhood Landmarks": "Lugares emblemáticos del barrio",
    "Cemeteries & Historic Grounds": "Cementerios y terrenos históricos",
    "Boat Tours & Sailing": "Paseos en barco y navegación",
    "Sunset & Catamaran Cruises": "Paseos al atardecer y en catamarán",
    "Kayaking & Paddleboarding": "Kayak y paddleboard",
    "Snorkeling & Diving": "Snorkel y buceo",
    "Surfing & Surf Lessons": "Surf y clases de surf",
    "Beach Clubs & Day Passes": "Clubes de playa y pases diarios",
    "Guided Walking Tours": "Recorridos guiados a pie",
    "Food & Rum Tastings": "Degustaciones de comida y ron",
    "Hiking & Rainforest Tours": "Senderismo y recorridos por el bosque tropical",
    "Ziplining & Adventure Parks": "Tirolesas y parques de aventura",
    "Horseback Riding": "Paseos a caballo",
    "Fishing Charters": "Excursiones de pesca",
    "Bike & Scooter Rentals": "Alquiler de bicicletas y scooters",
    "Photography Experiences": "Experiencias fotográficas",
    "Cultural Workshops & Classes": "Talleres y clases culturales",
    "Arcades & Retro Games": "Arcades y videojuegos retro",
    "Wellness & Retreats": "Bienestar y retiros",
    "ATV & Off-Road Tours": "Recorridos en ATV y todoterreno",
    "Horror & Haunted Experiences": "Experiencias de terror y casas embrujadas",
    "Day Trips & Excursions": "Excursiones y paseos de un día",
    "Party Bus & Karaoke Tours": "Recorridos en party bus y karaoke",
    "Eastern Metro Fringe": "Periferia este del área metro",
    "Western Metro Fringe": "Periferia oeste del área metro",
    "Metropolitan San Juan": "San Juan metropolitano",
    "Live Music": "Música en vivo",
    "Salsa & Dance": "Salsa y baile",
    Nightclubs: "Discotecas",
    "Karaoke & Piano Bars": "Karaoke y bares de piano",
    "Billiards & Game Bars": "Billares y bares de juegos",
    "Casinos & Gaming": "Casinos y juegos",
    "LGBTQ+ Nightlife": "Vida nocturna LGBTQ+",
    "Late-Night Eats": "Comida nocturna",
    "Botánicas & Spiritual Supplies": "Botánicas y artículos espirituales",
    "Souvenirs & Gifts": "Recuerdos y regalos",
    "Local Apparel & Boutiques": "Moda local y boutiques",
    "Jewelry & Accessories": "Joyería y accesorios",
    "Artisan Crafts": "Artesanía",
    "Independent Bookstores": "Librerías independientes",
    "Music & Records": "Música y discos",
    "Markets & Farmers Markets": "Mercados y mercados agrícolas",
    "Grocery & Specialty Foods": "Comestibles y alimentos especializados",
    "Coffee Roasters & Beans": "Tostadores de café y granos",
    "Rum & Spirits Shops": "Tiendas de ron y licores",
    "Cigar Shops": "Tiendas de cigarros",
    "Surf & Outdoor Gear": "Artículos de surf y para actividades al aire libre",
    "Beachwear & Swimwear": "Ropa de playa y trajes de baño",
    "Home Decor & Furniture": "Decoración y muebles para el hogar",
    "Chocolate & Sweets": "Chocolate y dulces",
    "Thrift & Vintage": "Tiendas de segunda mano y ropa vintage",
    "Pharmacy & Convenience": "Farmacias y tiendas de conveniencia",
    "Department Stores & Malls": "Tiendas por departamento y centros comerciales",
    "Pet Supplies": "Artículos para mascotas",
    "LGBTQ+ Dining": "Restaurantes LGBTQ+",
    "LGBTQ+ Stays": "Hospedajes LGBTQ+",
    "LGBTQ+ Community & Culture": "Comunidad y cultura LGBTQ+",
    "LGBTQ+ Services": "Servicios LGBTQ+",
    Barbershops: "Barberías",
    "Hair Salons & Stylists": "Salones de belleza y estilistas",
    "Nail Salons": "Salones de uñas",
    "Spas & Massage": "Spas y masajes",
    "Tattoo & Piercing Studios": "Estudios de tatuajes y perforaciones",
    "Fitness & Gyms": "Gimnasios y entrenamiento",
    "Yoga & Pilates Studios": "Estudios de yoga y pilates",
    "Dance Studios": "Estudios de baile",
    "Tailors & Alterations": "Sastrerías y arreglos de ropa",
    "Repair & Handyman Services": "Reparaciones y servicios de mantenimiento",
    "Photography & Videography": "Fotografía y videografía",
    "Professional Services": "Servicios profesionales",
    "Legal & Notary Services": "Servicios legales y notariales",
    "Printing & Shipping": "Impresión y envíos",
    "Coworking Spaces": "Espacios de coworking",
    "Car Rentals & Transportation": "Alquiler de autos y transporte",
    "Car Wash & Detailing": "Lavado y detallado de autos",
    "Tour Operators": "Operadores de recorridos",
    "Laundry & Dry Cleaning": "Lavandería y limpieza en seco",
    "Cleaning Services": "Servicios de limpieza",
    "Event & Party Services": "Servicios para eventos y fiestas",
    "Party Buses & Group Transportation": "Party buses y transporte para grupos",
    "Airport & Travel Hub": "Aeropuerto y centro de transporte",
    Travel: "Viajes",
    "Pet Services": "Servicios para mascotas",
    "Wellness & Alternative Therapy": "Bienestar y terapias alternativas",
    "Health & Medical Clinics": "Clínicas de salud y médicas",
    "Moving & Storage": "Mudanzas y almacenamiento",
    "Luggage Storage": "Consigna de equipaje",
  },
};

export const categoryLabel = (name, lang) => {
  const value = String(name ?? "").trim();
  if (!value) return value;
  if (lang !== "es") return value;
  const exact = CATEGORY_LABELS.es[value];
  if (exact) return exact;
  const normalized = value.toLowerCase();
  const match = Object.entries(CATEGORY_LABELS.es).find(([key]) => key.toLowerCase() === normalized);
  return match?.[1] || value;
};

const NEIGHBORHOOD_LABELS_ES = {
  "Old San Juan": "Viejo San Juan",
  "San Juan": "San Juan",
  "Río Piedras": "Río Piedras",
  "Ocean Park": "Ocean Park",
  "Puerta de Tierra": "Puerta de Tierra",
  "Isla Verde": "Isla Verde",
  "Condado": "Condado",
  "Santurce": "Santurce",
  "Hato Rey": "Hato Rey",
  "Miramar": "Miramar",
  "Cataño": "Cataño",
  "Bayamón": "Bayamón",
  "Carolina": "Carolina",
  "Guaynabo": "Guaynabo",
  "Caguas": "Caguas",
  "Piñones": "Piñones",
  "Puerto Rico": "Puerto Rico",
};

export const listingNameLabel = (listing, lang) => {
  if (lang === "es" && (listing?.source === "viator" || listing?.product_code)) return viatorTitleLabel(listing,lang);
  const name = String(listing?.name ?? listing?.title ?? "").trim();
  if (!name || lang !== "es") return name;
  if (listing?.coming_soon) {
    const translatedName = categoryLabel(name, "es");
    if (translatedName !== name) return translatedName;
    const translatedSubcategory = categoryLabel(listing?.subcategory || listing?.category || listing?.label, "es");
    if (translatedSubcategory && translatedSubcategory !== (listing?.subcategory || listing?.category || listing?.label)) return translatedSubcategory;
  }
  return name;
};

export const neighborhoodLabel = (name, lang) => {
  const value = String(name ?? "").trim();
  if (!value || lang !== "es") return value;
  if (NEIGHBORHOOD_LABELS_ES[value]) return NEIGHBORHOOD_LABELS_ES[value];
  return value
    .replace(/Old San Juan/gi, "Viejo San Juan")
    .replace(/Old Town/gi, "Casco histórico")
    .replace(/San Juan Historic District/gi, "Distrito histórico de San Juan");
};

const ACTION_LABELS_ES = {
  "Book Now": "Reservar ahora",
  "Book Experience": "Reservar experiencia",
  "Book Appointment": "Reservar cita",
  "Contact Business": "Contactar al negocio",
  "Reserve Table": "Reservar mesa",
  "Order Online": "Ordenar en línea",
  "View Menu": "Ver menú",
  "Shop Online": "Comprar en línea",
  "Visit Website": "Visitar sitio web",
  "Get Tickets": "Conseguir boletos",
  "Directions": "Cómo llegar",
  "Call": "Llamar",
  "View details": "Ver detalles",
  "Open the map": "Abrir el mapa",
  "Verified listing": "Negocio verificado",
  "Edit listing": "Editar listado",
  "GOOD TO KNOW": "INFORMACIÓN ÚTIL",
  "Area": "Zona",
};

export const actionLabel = (label, lang) =>
  lang === "es" ? (ACTION_LABELS_ES[label] || label) : label;

const PLANNER_LABELS_ES = {
  "YOUR PUERTO RICO":"TU PUERTO RICO","Your Trip":"Tu viaje","Tell us how you want to spend your time. Your plan adapts around your pace, interests, home base and the places you add.":"Cuéntanos cómo quieres pasar tu tiempo. El plan se adapta a tu ritmo, tus intereses, tu base y los lugares que añadas.",
  "in planner":"en el plan","Shape my trip":"Organizar mi viaje","Share with a friend":"Compartir con alguien","Our Puerto Rico trip":"Mi viaje por Puerto Rico","Copied":"Copiado","Copy trip":"Copiar viaje","Add day":"Añadir día","Trip planner":"Planificador de viaje","Get organized.":"Pon tu viaje en orden.",
  "Tell us what you have in mind. We’ll organize your places into a trip that makes sense for your time, interests and where you’re staying.":"Cuéntanos qué tienes en mente. Organizaremos tus lugares según el tiempo disponible, tus intereses y dónde te hospedas.",
  "How many days?":"¿Cuántos días?","Your pace":"Tu ritmo","Where are you based?":"¿Dónde te hospedas?","Budget":"Presupuesto","Keep it easy":"Sin gastar mucho","Flexible":"Flexible","Treat myself":"Darme un gusto","What sounds like you?":"¿Qué va contigo?","The trip should feel like…":"Tu viaje debería sentirse…","A little of everything":"Un poco de todo","Food first":"Primero, la comida","Beach + outdoors":"Playa y aire libre","Culture + local life":"Cultura y vida local","Night out":"Salir de noche","Organize my trip":"Organizar mi viaje",
  "Start with a few places you want to experience.":"Empieza con algunos lugares que quieras conocer.","Add restaurants, beaches, experiences and local spots. They become the starting point for your trip.":"Añade restaurantes, playas, experiencias y lugares locales. Serán el punto de partida de tu viaje.","Explore Puerto Rico":"Explorar Puerto Rico","Adjust anything as you go.":"Ajusta lo que quieras sobre la marcha.","Not scheduled yet":"Aún sin planificar","More places to fit in":"Más lugares para incluir","Start here":"Empieza aquí","Next move":"Siguiente parada","Worth the stop":"Vale la pena parar","Keep this one":"Guarda este lugar","One more thing":"Una cosa más","Don't miss":"No te lo pierdas","Leave room for one more thing":"Deja espacio para algo más","Keep going":"Sigue explorando","Remove day":"Eliminar día","Nothing here yet. Reshape the trip or move a saved place here.":"Todavía no hay nada aquí. Reorganiza el viaje o mueve un lugar guardado a este día.","Move to…":"Mover a…","Day":"Día","Book":"Reservar","Visit":"Visitar","Website":"Sitio web","Places":"Lugares","Events":"Eventos","Culture":"Cultura","Beach":"Playa","Adventure":"Aventura","Shopping":"Compras","Nightlife":"Vida nocturna"
};
export const plannerText = (value, lang) =>
  lang === "es" ? (PLANNER_LABELS_ES[value] || value) : value;

const DASHBOARD_LABELS_ES = {
  "Business dashboard":"Panel del negocio","View site →":"Ver sitio →","Your listings":"Tus listados",
  "Keep hours, photos and links current — changes go live on the site straight away.":"Mantén al día los horarios, las fotos y los enlaces; los cambios se reflejan enseguida en el sitio.",
  "Find another business":"Buscar otro negocio","No listings under your name yet":"Todavía no tienes negocios a tu nombre",
  "Find your business on the site and open its page.":"Busca tu negocio en el sitio y abre su página.",
  "Claim this business":"Reclamar este negocio","and tell us who you are.":"y cuéntanos quién eres.",
  "Once we approve it, it lands here with everything you can edit.":"Cuando lo aprobemos, aparecerá aquí con todo lo que puedes editar.",
  "Search the guide":"Buscar en la guía","Add a new business →":"Añadir un negocio nuevo →","Show all my businesses":"Mostrar todos mis negocios",
  "Basic":"Básico","Free":"Gratis","Everything in Basic":"Todo lo incluido en el plan Básico",
  "Your hours, phone, address and website kept current":"Horarios, teléfono, dirección y sitio web al día",
  "One photo and a description you write yourself":"Una foto y una descripción escrita por ti",
  "Listed as managed by its owner":"Listado identificado como administrado por su dueño",
  "Verified badge on your card, your page and your map pin":"Insignia de verificación en tu tarjeta, página y pin del mapa",
  "Instagram, Facebook, TikTok, X, YouTube and WhatsApp links":"Enlaces a Instagram, Facebook, TikTok, X, YouTube y WhatsApp",
  "Full photo gallery — up to six images":"Galería completa de hasta seis fotos",
  "Book, Order or Reserve button on your page":"Botón para reservar, ordenar o hacer una reservación en tu página",
  "/ month":"/ mes","or ":"o "," a year":" al año","Choose Premium":"Elegir Premium","Payments":"Pagos",
  "Submitted payments are confirmed by hand and switch on the same day.":"Los pagos enviados se verifican manualmente y el plan se activa ese mismo día.",
  "Pending":"Pendiente","Submitted":"Enviado","Approved":"Aprobado","Active":"Activo","Rejected":"Rechazado",
  "Premium is live on your listing — verified badge and all.":"El plan Premium ya está activo en tu listado, incluida la insignia de verificación.",
  "That payment hasn't cleared yet. We'll switch Premium on as soon as it does.":"El pago todavía no se ha confirmado. Activaremos Premium en cuanto se procese.",
  "We couldn't confirm that payment yet.":"Todavía no pudimos confirmar ese pago.",
  "Checkout cancelled — nothing was charged.":"Se canceló el pago; no se hizo ningún cargo.",
  "Edit listing":"Editar listado","Close":"Cerrar","Business name":"Nombre del negocio","Category":"Categoría","— Select —":"— Seleccionar —",
  "Subcategory":"Subcategoría","What you'd tell a friend":"Lo que le contarías a una amistad","Address":"Dirección","Phone":"Teléfono","Hours":"Horario","Website":"Sitio web",
  "Cover photo":"Foto de portada","Front of business":"Fachada del negocio","Gallery (up to six)":"Galería (hasta seis fotos)","Gallery (one photo on Basic)":"Galería (una foto en el plan Básico)",
  "Social links":"Enlaces de redes sociales","Booking button":"Botón de reserva","Button":"Botón","— None —":"— Ninguno —","Button link":"Enlace del botón",
  "Everything here is yours on Basic. Social links, the booking button and a full gallery unlock with Premium — upgrade from your listing card and they switch on the moment payment lands.":"Todo esto está incluido en el plan Básico. Los enlaces sociales, el botón de reserva y la galería completa se activan con Premium; mejora tu plan desde la tarjeta del listado y estarán disponibles cuando se procese el pago.",
  "Some Premium-only fields were left untouched.":"Algunos campos exclusivos de Premium no se modificaron.","Cancel":"Cancelar","Save changes":"Guardar cambios","Could not save":"No se pudo guardar",
  "Business packages":"Planes para negocios","Payment submitted":"Pago enviado","We check {method} payments by hand and switch Premium on as soon as it lands — usually the same day. Your verified badge, links and gallery unlock the moment it does.":"Verificamos manualmente los pagos por {method} y activamos Premium en cuanto se reciben, normalmente el mismo día. La insignia, los enlaces y la galería se habilitan entonces.",
  "Back to my listings":"Volver a mis listados","Your listing, managed by you.":"Tu listado, administrado por ti.","Verified":"Verificado","per year":"al año","per month":"al mes","Billing period":"Período de facturación",
  "Monthly":"Mensual","Yearly":"Anual","How you'd like to pay":"Cómo quieres pagar","Confirmation number":"Número de confirmación","Anything we should know (optional)":"¿Algo más que debamos saber? (opcional)",
  "Pay":"Pagar","by card":"con tarjeta","Continue with":"Continuar con","Allow pop-ups to continue to checkout.":"Permite las ventanas emergentes para continuar al pago.",
  "Checkout could not be started":"No se pudo iniciar el pago","Card checkout failed":"No se pudo completar el pago con tarjeta","That didn't go through. Please try again.":"No se pudo completar. Inténtalo de nuevo.",
  "Secure Stripe checkout — Premium switches on instantly.":"Pago seguro con Stripe; Premium se activa al instante.","Pay from your PayPal balance or account.":"Paga desde tu saldo o cuenta de PayPal.","Send from any Puerto Rico bank or credit union app.":"Envía el pago desde la aplicación de cualquier banco o cooperativa de Puerto Rico.",
  "Profile":"Perfil","Enhanced":"Mejorado","Standard":"Estándar","Edit":"Editar","Extend":"Extender","Upgrade":"Mejorar plan","View page":"Ver página",
  "Basic · Free":"Básico · Gratis"
};
export const dashboardText = (value, lang) =>
  lang === "es" ? (DASHBOARD_LABELS_ES[value] || value) : value;

// FAQ questions are stored under a bucket id (see src/data/faq.js); this is only
// how that bucket reads on screen.
const FAQ_CATEGORY_LABELS = {
  es: {
    basics: "Lo básico",
    "getting-around": "Cómo moverte",
    money: "Dinero y costos",
    "beaches-weather": "Playas y clima",
    "food-drink": "Comida y bebida",
    tours: "Tours y reservas",
    safety: "Seguridad y salud",
    culture: "Cultura y etiqueta",
  },
};

export const faqCategoryLabel = (id, lang) =>
  FAQ_CATEGORY_LABELS[lang]?.[id] || FAQ_CATEGORY_BY_ID[id]?.label || id;

export const DICTS = {
  en: {
    "nav.explore": "Explore",
    "nav.map": "Map",
    "nav.events": "Events",
    "nav.saved": "Saved",
    "nav.planner": "My List",
    "nav.magazine": "Magazine",
    "nav.faq": "Blog",
    "nav.tagline": "Puerto Rico's local guide",
    "tools.title": "Site tools",
    "tools.appearance": "Appearance",
    "tools.light": "Light",
    "tools.dark": "Dark",
    "tools.language": "Language",
    "gate.kicker": "Welcome",
    "gate.title": "Choose your language",
    "gate.sub": "You can switch it any time from the footer.",
    "menu.open": "Open menu",
    "menu.close": "Close menu",
    "menu.browse": "Browse",
    "menu.categories": "Categories",
    "menu.neighborhoods": "Neighborhoods",
    "menu.allNeighborhoods": "See all on the map",
    "menu.forBusiness": "For business",
    "menu.more": "More",
    "menu.ownerTools": "My business",
    "menu.claim": "Claim a business",
    "menu.dashboard": "Business dashboard",
    "menu.adDashboard": "Ad campaigns",
    "menu.admin": "Admin",
    "search.placeholder": "Search places, food, experiences...",
    "search.placeholderShort": "Search San Juan...",
    "search.clear": "Clear",
    "search.submit": "Search",
    "hero.kicker": "Puerto Rico, beyond the postcard",
    "hero.line1": "See more of",
    "hero.line2": "Puerto Rico.",
    "hero.blurb": "Local places. Good food. Real experiences. See another side of the island.",
    "hero.tags": "Food · Culture · Places · Experiences",
    "experiences.noMatch": "No experiences match your search or filters.",
    "experiences.seeAll": "See all {count}",
    "hero.places": "{count} local places to explore",
    "hero.placeOne": "1 local place to explore",
    "browse.gastronomy": "Eat",
    "browse.nightlife": "Drink",
    "browse.shop": "Shop",
    "browse.do": "Do",
    "browse.services": "Services",
    "browse.stays": "Stays",
    "browse.auto": "Rent a car",
    "browse.jobs": "Jobs in Puerto Rico",
    "browse.filters": "Filters",
    "browse.showing": "Showing {category} · Clear",
    "browse.clearFilters": "Clear filters",
    "browse.mood": "Start with a mood, not a category.",
    "browse.byCategory": "Browse by category",
    "categoryHint.gastronomy": "Places to eat and drink",
    "categoryHint.nightlife": "Bars, clubs and live music",
    "categoryHint.shop": "Boutiques and local goods",
    "categoryHint.do": "Tours, excursions and activities",
    "categoryHint.services": "Local services, wellness and personal care",
    "home.neighborhoodGuide": "Neighborhood Guide",
    "home.rightNowKicker": "Right now",
    "home.openInPuertoRico": "Open in Puerto Rico",
    "home.openInPuertoRicoSub": "Quickly see which local spots are open right now, based on their listed hours.",
    "home.trendingTitle": "What's Happening",
    "home.trendingSub": "What's happening around Puerto Rico",
    "home.chinchorrosTitle": "Chinchorros & Kiosks",
    "home.chinchorrosSub": "Roadside kiosks, open-air grills and local Puerto Rican food.",
    "home.localPicksTitle": "Local Finds",
    "home.localPicksSub": "Local spots worth knowing",
    "home.viewsTitle": "Rooftops & Views",
    "home.viewsSub": "Rooftops, views and places to linger",
    "home.foodTitle": "Food & Drink",
    "home.foodSub": "Food, coffee and places to stay awhile",
    "home.cultureTitle": "Puerto Rico, Up Close",
    "home.cultureSub": "Culture, places and stories worth knowing",
    "home.experiencesTitle": "Things to Do",
    "home.experiencesSub": "Experiences beyond the postcard",
    "home.collectionsTitle": "Around Here",
    "home.collectionsSub": "Places, neighborhoods and corners worth exploring.",
    "home.loadError": "We could not load the guide right now. Please refresh the page to try again.",
    "nav.primary": "Primary navigation",
    "browse.categories": "Browse categories",
    "carousel.previous": "Previous places",
    "carousel.next": "Next places",
    "services.title": "Local Services",
    "services.noMatch": "No services match those filters.",
    "services.blurb": "Browse local services and find businesses in the area.",
    "category.noStays": "No stays found yet.",
    "category.noMatch": "No places match those filters.",
    "events.thisWeek": "This week",
    "events.nextSevenDays": "What's on over the next seven days.",
    "events.openCalendar": "Open calendar",
    "events.comingUp": "Coming up",
    "events.islandCalendar": "Everything else on the island's calendar.",
    "category.more": "More {category}",
    "guide.neighborhoodKicker": "Ya Tú Sabes · Neighborhood Guide",
    "guide.openMap": "Open the map",
    "guide.localPlaces": "local places",
    "guide.localGuide": "Puerto Rico local guide",
    "guide.exploreMap": "Explore the map",
    "guide.places": "places",
    "guide.loading": "Loading the local guide…",
    "guide.moreComing": "More local listings are being added.",
    "guide.widerArea": "Use the map to explore the wider area.",
    "guide.picked": "Picked for this guide",
    "guide.worthKnowing": "Worth knowing",
    "guide.picks": "picks",
    "guide.placesToExplore": "Places to explore",
    "guide.explore": "Explore",
    "guide.category.restaurants": "Restaurants",
    "guide.category.bars-nightlife": "Bars & Nightlife",
    "guide.category.things-to-do": "Things to Do",
    "guide.category.beaches": "Beaches",
    "guide.category.shopping": "Shopping",
    "guide.category.culture": "Culture",
    "guide.category.services": "Services",
    "rail.viator": "Found on Tripadvisor",
    "rail.foundOn": "Found on",
    "rail.viatorSub": "The tours, cruises and adventures travelers book most — reserved securely through our booking partner",
    "rail.trending": "Trending in Puerto Rico",
    "rail.locals": "Locals' Picks",
    "rail.neighborhoods": "Browse by Neighborhood",
    "rail.chinchorros": "Chinchorros & Kiosks",
    "rail.chinchorrosSub": "Roadside kiosks, open-air grills and no-frills criollo kitchens.",
    "rail.eatdrink": "Gastronomy",
    "rail.vegan": "Vegan & Vegetarian",
    "rail.culture": "Culture & History",
    "rail.experiences": "Experiences",
    "rail.offbeaten": "Off the Beaten Path",
    "rail.offbeatenSub": "The coves, lookouts and small kitchens most visitors never reach.",
    "rail.rooftops": "Rooftops & Views",
    "rail.beachesSub": "Hidden coves & saltwater pools",
    "results.one": "1 result",
    "results.many": "{count} results",
    "results.clear": "Clear",
    "results.none": "No places match your search or filters.",
    "nav.all": "ALL",
    "nearMe.title": "Near Me",
    "nearMe.hint": "See what's closest to you first",
    "nearMe.locating": "Finding your location…",
    "nearMe.active": "Showing the places closest to you first",
    "nearMe.error": "We couldn't read your location — allow it in your browser and try again.",
    "nearMe.unavailable": "This device can't share a location.",
    "nearMe.results": "{count} ways to experience Puerto Rico",
    "rail.nearYou": "Near You",
    "map.whereAmI": "Where Am I?",
    "map.locating": "Finding…",
    "map.onTheMap": "On the map",
    "map.tapToExplore": "Tap to explore",
    "map.exploring": "Exploring the map",
    "map.exploreSub": "Neighborhoods · Dining · Beaches",
    "map.nearMeCta": "What's near me?",
    "map.viewOnMap": "View on map",
    "map.moreInfo": "More info",
    "map.tapToCollapse": "Tap to Collapse",
    "detail.save": "Save",
    "detail.share": "Share",
    "detail.directions": "Directions",
    "detail.call": "Call",
    "detail.social": "Social",
    "social.pending": "Not shared yet",
    "detail.essential": "Essential Info",
    "detail.location": "Location",
    "detail.beach": "Beach guide",
    "detail.about": "About",
    "detail.community": "Community Experiences & Local Tips",
    "detail.noStories": "No stories yet. Be the first to share.",
    "detail.price": "Price",
    "detail.hours": "Hours",
    "hours.today": "Today",
    "hours.open": "Open now",
    "hours.closed": "Closed",
    "hours.opensAt": "opens {time}",
    "hours.opensOn": "opens {day} {time}",
    "hours.opensTomorrow": "opens tomorrow {time}",
    "hours.closesAt": "closes {time}",
    "card.open": "Open",
    "card.closingSoon": "Closing soon",
    "card.closed": "Closed",
    "card.openingSoon": "Opening soon",
    "card.closesAt": "Closes {time}",
    "card.opensAt": "Opens {time}",
    "card.opensTomorrow": "Tomorrow {time}",
    "card.opensOn": "{day} {time}",
    "hours.allDays": "All days",
    "hours.hideDays": "Hide days",
    "hours.daily": "Daily",
    "hours.closedDay": "Closed",
    "hours.editTitle": "Weekly hours",
    "hours.editHint": "Set the days you're open. Anything left shut reads as closed; the pill below is exactly what a visitor sees.",
    "hours.lineLabel": "Or write the hours out",
    "hours.lineHint": "Filled from the days above. Use it on its own when the week is irregular.",
    "hours.preview": "How it reads",
    "hours.applyAll": "Use {day}'s hours for every day",
    "hours.aiTitle": "Hours from a sentence",
    "hours.aiHint": "Write the hours the way you'd say them — English or Spanish, loose is fine.",
    "hours.aiPlaceholder": "e.g. Tue–Sun 11am–9pm, closed Mondays",
    "hours.aiButton": "Fill the week",
    "hours.aiWorking": "Filling…",
    "hours.aiError": "Couldn't read that one. Try writing the hours another way.",
    "detail.address": "Address",
    "detail.phone": "Phone",
    "detail.languages": "Languages",
    "detail.web": "Web",
    "detail.amenities": "Amenities",
    "detail.visitWebsite": "Visit website",
    "detail.submit": "Share",
    "detail.submitting": "Submitting…",
    "detail.yourName": "YOUR NAME",
    "detail.tipPlaceholder": "Share your experience or a local tip…",
    "detail.bookViator": "Book on Viator",
    "detail.aboutExperience": "About this experience",
    "detail.translationPending": "A Spanish translation of the full description is being prepared. Check the booking page for complete details before reserving.",
    "detail.included": "What's included",
    "detail.goodToKnow": "Good to know",
    "detail.duration": "Duration",
    "detail.from": "From",
    "detail.meeting": "Meeting",
    "detail.cancellation": "Cancellation",
    "detail.availability": "Availability",
    "detail.availabilityText": "Live dates, times and pricing are shown on Viator when you book.",
    "detail.bookedVia": "Booked via",
    "detail.perPerson": "per person",
    "detail.reviews": "reviews",
    "detail.handledBy": "Payment handled by Viator",
    "detail.stayNote": "You stay on Ya Tú Sabes PR while you browse — payment and confirmation are handled securely by Viator (TripAdvisor), and this page stays open.",
    "detail.experienceNotFound": "Experience not found",
    "detail.experienceGone": "This bookable experience is no longer listed.",
    "detail.back": "Back",
    "nav.business": "For business",
    "claim.owner": "Own this business?",
    "claim.blurb": "Own this business? Claim it to keep the photos, hours and links current.",
    "claim.cta": "Claim now",
    "claim.bannerTitle": "Own this business? Claim your page.",
    "claim.bannerSub": "Manage your photos, hours and details. Founding first-year plan: $100.",
    "claim.bannerCta": "Claim",
    "claim.managed": "Managed by the owner",
    "claim.mine": "You manage this listing",
    "claim.dashboard": "Open business dashboard",
    "claim.title": "Claim this business",
    "claim.intro": "The first-year listing claim is $100. Submit your details for manual review; this form does not charge you. We'll contact you to verify the business and explain the next step.",
    "claim.name": "Your name",
    "claim.email": "Email",
    "claim.phone": "Phone",
    "claim.role": "Your role at the business",
    "claim.link": "Website or social link",
    "claim.note": "Anything that helps us confirm it",
    "claim.submit": "Send claim",
    "claim.sending": "Sending…",
    "claim.sent": "Claim received",
    "claim.sentBlurb": "We review claims within a couple of days. You can follow it from your business dashboard.",
    "claim.sentGuest": "Your claim was sent to our team for review. We’ll follow up by email. No account needed.",
    "claim.review": "Your claim is under review",
    "claim.reviewBlurb": "We'll email you as soon as it's approved.",
    "claim.signIn": "Sign in to claim",
    "claim.signInBlurb": "Claims are tied to your account so you can manage the listing afterwards.",
    "claim.error": "That didn't go through. Please try again.",
    "claim.required": "Please add your name, email and phone.",
    "share.title": "Share this find",
    "share.subtitle": "Send it to a friend — every link opens right here.",
    "share.native": "Share from your phone",
    "share.copy": "Copy link",
    "share.copied": "Link copied",
    "share.scan": "Or let someone scan this code — it opens right here.",
    "share.listTitle": "My Puerto Rico list",
    "share.listCount": "{count} saved",
    "share.listIntro": "Saved on Ya Tú Sabes PR, the local guide to the island:",
    "share.listOutro": "Build your own list:",
    "share.copyList": "Copy list",
    "share.copiedList": "List copied",
    "story.back": "All stories",
    "story.by": "By",
    "story.read": "{count} min read",
    "story.places": "Places in this story",
    "faq.kicker": "Ya Tú Sabes · Good to know",
    "faq.title": "Puerto Rico, answered.",
    "faq.blurb":
      "Straight answers to what travelers ask most — getting around, money, beaches, food, safety and the small details nobody tells you.",
    "faq.searchPlaceholder": "Search questions…",
    "faq.all": "All",
    "faq.loading": "Loading questions…",
    "faq.empty": "No questions match that search.",
    "faq.magazine": "From the magazine",
    "faq.magazineSub": "Longer reads from around the island — history, food and local perspective.",
    "blog.kicker": "The Ya Tú Sabes magazine",
    "blog.brand": "Blog",
    "blog.tagline":
      "What's moving on the island right now — neighborhood comebacks, new openings and the people behind them. The answers people actually ask for are right underneath.",
    "blog.feature": "The feature",
    "blog.latest": "Latest stories",
    "blog.readStory": "Read the story",
    "blog.faqJump": "FAQ",
    "nav.about": "About",
    "nav.contact": "Contact",
    "footer.tagline": "Puerto Rico's Local Guide — neighborhoods, food, culture and experiences.",
    "footer.made": "Made in Puerto Rico.",
    "nav.privacy": "Privacy Policy",
    "nav.terms": "Terms of Service",
    "legal.updated": "Last updated",
    "about.kicker": "About Ya Tú Sabes PR",
    "about.title": "A living guide to Puerto Rico.",
    "about.lead":
      "Ya Tú Sabes PR is a free, independent local guide built in Puerto Rico to connect visitors and residents with the places, people, culture, events, businesses and experiences that make the island what it is.",
    "about.founderTitle": "Why this exists",
    "about.founderHeadline": "I moved to Río Piedras to see for myself.",
    "about.founder":
      "When I moved from Virginia to Puerto Rico, I decided to treat one choice as an experiment: I moved to Río Piedras. Plenty of people warned me not to. I heard that the neighborhood was horrible, that there was nothing to do, and that I would be better off somewhere more familiar or more obviously geared toward visitors. I wanted to experience it for myself instead of letting someone else's reputation decide what I might find. What I found was almost the opposite. Río Piedras has food with flavor and personality, useful everyday services, independent businesses, welcoming people, culture, and the kind of unexpected encounters that make a place feel alive. It also has real challenges and moments of unpredictability; pretending otherwise would not be honest. But uncertainty exists in cities and communities around the world. It is a reason to stay aware, learn the area, and make thoughtful choices—not a reason to write off an entire neighborhood or decide that everyone should simply stay home. My experience made me ask why so much attention goes to a narrow set of familiar destinations while other communities with so much to offer remain harder to find. I believe Río Piedras and neighborhoods like it deserve to be seen on their own terms: for their amenities, services, food, creativity, hospitality, and people—not as an afterthought or a warning label. Ya Tú Sabes PR grew from that conviction. I want to help bridge the gaps in local tourism promotion and access to information, starting in San Juan and nearby communities, so residents and visitors can find more of what is already here and local businesses have a fairer chance to be seen.",
    "about.founderName": "Founder & editor, Ya Tú Sabes PR",
    "about.whatTitle": "What this is",
    "about.ideaLabel": "The idea",
    "about.audienceLabel": "Who it is for",
    "about.builtHereLabel": "Built here",
    "about.statPlaces": "Places",
    "about.statEvents": "Events",
    "about.statCulture": "Culture",
    "about.statBook": "Book",
    "about.what":
      "We are building a free, easy-to-use bridge between people and the places around them: neighborhood businesses, restaurants, shops, markets, cultural spaces, nightlife, events, outdoor spots and bookable experiences. We want locals to find something new close to home and visitors to experience more than the best-known stops. Ya Tú Sabes PR is a startup, and the guide is free to use. We have not raised donations or outside funding. Booking partners such as Viator, Tripadvisor and GetYourGuide may provide referral commissions when someone books through their links, but community support is important to helping us improve coverage, maintain the platform and bring more local stories and businesses into view.",
    "about.whoTitle": "Who it's for",
    "about.who":
      "Travelers planning a first trip. Returning visitors who want to get past the postcard. Locals looking for what just opened around the corner. And the owners of the businesses on these pages — claim your listing and we'll help keep your hours, photos and links accurate.",
    "about.teamTitle": "Who builds it",
    "about.team":
      "Ya Tú Sabes PR is an independent startup built in Puerto Rico. We are working to close gaps in how local tourism, neighborhood businesses and cultural experiences are promoted—starting in San Juan and nearby communities, then growing as we can. The resource remains free for visitors and residents. At this stage, there is no outside funding or donation pool behind the site; some booking links may earn referral commissions. Donations and community support can help us keep the guide accessible while expanding the places and voices represented.",
    "about.supportLabel": "Keep it growing",
    "about.supportTitle": "Help keep this guide free and independent.",
    "about.supportBody": "We are building this in stages, with no outside funding or donation pool behind the site. If this guide has helped you find a place or plan a day, reach out about supporting the next stage of the project.",
    "about.supportButton": "Support the project",
    "about.contactTitle": "Talk to us",
    "about.contact": "Questions, corrections, or a place we should know about? Send us a note — we read every one.",
    "contact.kicker": "Contact Ya Tú Sabes PR",
    "contact.title": "Say hola.",
    "contact.blurb":
      "Questions, corrections, a place we should know about, or a listing you want to claim — send a note and it lands in our inbox in Puerto Rico.",
    "contact.name": "Your name",
    "contact.email": "Your email",
    "contact.message": "Your message",
    "contact.messagePlaceholder": "Tell us what's on your mind…",
    "contact.send": "Send message",
    "contact.sending": "Sending…",
    "contact.successTitle": "Message sent",
    "contact.success": "Thanks — your note is on its way. We usually reply within a couple of days.",
    "contact.another": "Send another message",
    "contact.error": "That didn't go through. Please try again.",
    "contact.required": "Please fill in your name, email and message.",
    "contact.directTitle": "Write to us directly",
    "contact.directNote":
      "Prefer your own mail app? The same small team reads it — usually within a couple of days.",
    "contact.basedIn": "Written, photographed and maintained in Puerto Rico",
    "nav.advertise": "Advertise",
    "ads.label": "Advertising",
    "ads.cta": "Advertise here",
    "ads.blurb": "Put your business in front of people planning their next stop in Puerto Rico.",
    "ads.available": "Space available",
    "ads.seeSpaces": "See the ad spaces",
    "ads.sponsored": "Sponsored",
    "ads.visit": "Visit site",
    "advertise.kicker": "Advertising on Ya Tú Sabes PR",
    "advertise.title": "Anúnciate aquí.",
    "advertise.lead":
      "One island, one guide. Our spaces sit where people are choosing where to eat, sleep and go — and they stay quiet on purpose, so your name gets read instead of skipped.",
    "advertise.howTitle": "How it works",
    "advertise.how1": "Pick a space. Every price below is per month, per advertiser.",
    "advertise.how2": "One partner per space at a time — no competitor shares your placement.",
    "advertise.how3": "We build it, keep it live and send you the numbers at the end of the month.",
    "advertise.spacesTitle": "Live on the site now",
    "advertise.requestTitle": "On request",
    "advertise.slotsLabel": "slots",
    "advertise.month": "month",
    "advertise.boardTitle": "The full board",
    "advertise.boardNote":
      "{slots} monthly slots across {live} live placements — {total} a month with every space sold. Most partners start with one and renew.",
    "advertise.formTitle": "Ask about a space",
    "advertise.formBlurb":
      "Tell us about the business and the space you're after. We reply with availability, dates and a mock-up of your placement.",
    "advertise.business": "Business name",
    "advertise.space": "Space you're interested in",
    "advertise.note": "What you have in mind",
    "advertise.notePlaceholder": "Tell us about the business, the timing and the budget you're working with…",
    "advertise.send": "Send enquiry",
    "advertise.sending": "Sending…",
    "advertise.sentTitle": "Enquiry sent",
    "advertise.sent": "Thanks — we have your note and will come back with availability and a mock-up of the space.",
    "advertise.another": "Send another enquiry",
    "advertise.how4":
      "Pay by card. Stripe takes the payment, one month at a time, and your space goes live as soon as it clears.",
    "advertise.dashCta": "Open the advertiser dashboard",
    "advertise.askCta": "Ask us a question",
    "advertise.goalLabel": "Our running goal",
    "advertise.payNote":
      "Card payments run through Stripe and cover one month in one space. Nothing renews on its own, and you can change the artwork whenever you like.",
    "adDash.navLink": "Advertiser dashboard",
    "adDash.kicker": "Advertiser dashboard",
    "adDash.title": "Your ad spaces.",
    "adDash.lead":
      "Book a space, upload your artwork, pay for the month you want to run, and change the creative whenever you like. Your space goes live as soon as the payment clears.",
    "adDash.signedIn": "Signed in as {email}",
    "adDash.backToRates": "See the spaces and prices",
    "adDash.yoursTitle": "Your campaigns",
    "adDash.empty": "Nothing booked yet. Choose a space below, upload your artwork, then pay for the month you want.",
    "adDash.newTitle": "Book a space",
    "adDash.newBlurb":
      "One space, one month, one advertiser. You can change the creative as often as you like while your month runs.",
    "adDash.business": "Business name",
    "adDash.space": "Space",
    "adDash.headline": "Headline",
    "adDash.headlinePlaceholder": "What should people read first?",
    "adDash.line": "One supporting line",
    "adDash.linePlaceholder": "Optional — where you are, or what you're known for",
    "adDash.link": "Where the ad sends people",
    "adDash.art": "Artwork",
    "adDash.artReady": "Artwork uploaded and ready to run.",
    "adDash.replace": "Replace",
    "adDash.removeArt": "Remove artwork",
    "adDash.upload": "Upload artwork",
    "adDash.uploading": "Uploading…",
    "adDash.uploadError": "That image could not be uploaded. Try a PNG or JPG.",
    "adDash.artHint": "PNG, JPG or WebP. Artwork is stored publicly — every visitor to the site sees it.",
    "adDash.spacePrice": "{price} a month in this space, {size}.",
    "adDash.create": "Save this ad",
    "adDash.saving": "Saving…",
    "adDash.saveChanges": "Save changes",
    "adDash.cancel": "Cancel",
    "adDash.edit": "Edit",
    "adDash.delete": "Delete",
    "adDash.pay": "Pay {price} for one month",
    "adDash.paying": "Opening checkout…",
    "adDash.runsUntil": "runs until {date}",
    "adDash.live": "Payment received — your space is live.",
    "adDash.pending": "That payment has not cleared yet. If you paid, the space switches on within a minute or two.",
    "adDash.cancelled": "Checkout cancelled — nothing was charged.",
    "adDash.required": "Add a business name, a headline, a web address and your artwork before saving.",
    "adDash.saveError": "That could not be saved. Try again.",
    "adDash.payError": "Checkout could not be started. Try again.",
    "adDash.status.Draft": "Draft",
    "adDash.status.Awaiting payment": "Awaiting payment",
    "adDash.status.Active": "Live",
    "adDash.status.Paused": "Paused",
    "adDash.status.Expired": "Finished",
    "join.kicker": "For businesses & experiences",
    "join.title": "Put your place on the island's guide.",
    "join.lead":
      "Ya Tú Sabes PR is where travelers plan Puerto Rico and where locals look for what just opened. Join the guide and we build you a page people actually find — on the map, in the rails and in search.",
    "join.ctaAdd": "Add your business",
    "join.ctaExplore": "See the guide",
    "join.fact1": "Read in English and Spanish",
    "join.fact2": "On the map, in the rails and in search",
    "join.fact3": "Hours, photos and links you keep current yourself",
    "join.pathsTitle": "Two ways in",
    "join.pathsBlurb": "Pick the one that fits what you run — the price is the only difference.",
    "join.localTitle": "Bars, restaurants, shops & services",
    "join.localBlurb":
      "Chinchorros, cafés, bakeries, bars, boutiques, galleries, stays and local services — anywhere travelers and locals walk in.",
    "join.freeTag": "Freemium",
    "join.freePrice": "Free",
    "join.freeBlurb": "A real page in the guide, at no cost, for as long as you like.",
    "join.free1": "Name, type, neighborhood, hours and phone",
    "join.free2": "One photo and a description",
    "join.free3": "Editable by you from your own dashboard",
    "join.subTag": "Subscription",
    "join.perMonth": "/ month",
    "join.subBlurb": "For the businesses that want to stand out and be bookable.",
    "join.sub1": "Verified badge on your card, your page and your map pin",
    "join.sub2": "Full photo gallery, social links and WhatsApp",
    "join.sub3": "Book, Order or Reserve button on your page",
    "join.subYearly": "Or {yearly} a year.",
    "join.expTitle": "Experiences, tours & activities",
    "join.expBlurb":
      "Guides, charters, tastings, surf lessons, food crawls — anything you run that travelers book.",
    "join.flatTag": "Flat fee",
    "join.flatBlurb": "One set monthly fee. No commission on anything you sell.",
    "join.flat1": "Your own page, priced and linked to your booking system",
    "join.flat2": "Featured in the experiences rail and on the map",
    "join.commTag": "Commission",
    "join.commPrice": "Commission on bookings",
    "join.commBlurb":
      "The rate your company already offers partners — we agree the terms together, and you pay only as you book.",
    "join.comm1": "No monthly fee",
    "join.comm2": "Travelers book through the system you already use",
    "join.expNote":
      "Either way you keep selling through your own booking system — we send travelers straight to it.",
    "join.stepsTitle": "How it works",
    "join.step1": "Send us your details",
    "join.step1Body": "Two minutes, no account needed.",
    "join.step2": "We build your page",
    "join.step2Body":
      "We write it, add your photos and place you on the map — you approve it before it goes live.",
    "join.step3": "You run it yourself",
    "join.step3Body":
      "Hours, photos, links and your plan, edited from your dashboard and live straight away.",
    "join.formTitle": "Add your business or experience",
    "join.formBlurb": "Tell us who you are and we take it from there.",
    "join.bizName": "Business name",
    "join.kind": "What are you adding?",
    "join.kindFood": "Restaurant, bar or café",
    "join.kindShop": "Shop or boutique",
    "join.kindStay": "Hotel or guesthouse",
    "join.kindService": "Local service",
    "join.kindExperience": "Experience or tour",
    "join.kindOther": "Something else",
    "join.area": "Neighborhood or town",
    "join.contactName": "Your name",
    "join.email": "Email",
    "join.phone": "Phone",
    "join.link": "Website or social link",
    "join.plan": "How would you like to join?",
    "join.planFree": "Freemium — free listing",
    "join.planSubscription": "Subscription — monthly plan",
    "join.planExpFlat": "Experience — {price} a month flat",
    "join.planExpCommission": "Experience — commission on bookings",
    "join.notes": "Anything we should know?",
    "join.notesPlaceholder": "Tell us about the place, the hours, the story…",
    "join.submit": "Send my details",
    "join.sending": "Sending…",
    "join.required": "Please add your business name, your name and an email.",
    "join.error": "That didn't go through. Please try again.",
    "join.sentTitle": "Got it.",
    "join.sentBlurb":
      "We go over your details and email you — usually within a couple of days — with your page and the next step.",
    "join.another": "Add another business",
    "join.ownerTitle": "Already on the guide?",
    "join.ownerBlurb":
      "Find your business on the site and claim it. Once we confirm it's yours, the page lands in your dashboard, ready to edit.",
    "join.ownerCta": "Find your business",
    "join.dashboardCta": "Owner dashboard",

    // --- Admin ---
    "admin.title": "YTS Admin",
    "admin.dashboard": "Dashboard",
    "admin.viewSite": "View site →",
    "admin.adminsOnly": "Admins only",
    "admin.adminsOnlyBody": "You need an admin account to access this page.",
    "admin.backHome": "Back home",
    "admin.tab.Listing": "Listings",
    "admin.tab.Category": "Categories",
    "admin.tab.Neighborhood": "Neighborhoods",
    "admin.tab.Story": "Stories",
    "admin.tab.Viator": "Viator",
    "admin.tab.BusinessClaim": "Business claims",
    "admin.tab.PlanUpgrade": "Premium requests",
    "admin.listings": "Listings",
    "admin.new": "New",
    "admin.loading": "Loading…",
    "admin.empty": "No listings yet.",
    "admin.noMatches": "Nothing matches these filters.",
    "admin.shown": "{count} shown",
    "admin.filter.all": "All",
    "admin.filter.experiences": "Experiences",
    "admin.filter.beaches": "Beaches",
    "admin.filter.services": "Services",
    "admin.filter.comingSoon": "Coming soon",
    "admin.searchPlaceholder": "Search by name…",
    "admin.allNeighborhoods": "All neighborhoods",
    "admin.badge.Published": "Published",
    "admin.badge.Draft": "Draft",
    "admin.badge.Archived": "Archived",
    "admin.badge.comingSoon": "Coming soon",
    "admin.plan.Free": "Free",
    "admin.plan.Premium": "Premium",
    "admin.edit": "Edit",
    "admin.view": "View",
    "admin.delete": "Delete",
    "admin.show": "Show on the site",
    "admin.hide": "Hide from the site",
    "admin.editListing": "Edit listing",
    "admin.newListing": "New listing",
    "admin.s.basic": "Basic info",
    "admin.s.beach": "Beach guide",
    "admin.s.location": "Location & contact",
    "admin.s.hours": "Hours",
    "admin.s.social": "Social links",
    "admin.s.action": "Primary action & affiliate",
    "admin.s.media": "Media & visuals",
    "admin.s.details": "Details & features",
    "admin.f.name": "Name",
    "admin.f.pageLink": "Page link",
    "admin.f.type": "Type",
    "admin.f.category": "Category",
    "admin.f.subcategory": "Subcategory",
    "admin.f.neighborhood": "Neighborhood",
    "admin.f.trending": "Trending position",
    "admin.f.trendingHint": "Only for a Featured place: its spot in Trending in Puerto Rico. Leave it empty and it falls in line behind the numbered ones.",
    "admin.f.coords": "Coordinates / location",
    "admin.f.coordsHint": "Paste coordinates or a Google Maps link directly (e.g. 18.4655, -66.1180)",
    "admin.f.parsed": "Parsed",
    "admin.f.address": "Address",
    "admin.f.phone": "Phone",
    "admin.f.website": "Website",
    "admin.f.booking": "Booking URL",
    "admin.f.whatsapp": "WhatsApp number / link",
    "admin.f.instagram": "Instagram",
    "admin.f.facebook": "Facebook",
    "admin.f.tiktok": "TikTok",
    "admin.f.twitter": "X / Twitter",
    "admin.f.youtube": "YouTube",
    "admin.f.actionType": "Primary action type",
    "admin.f.affiliate": "Affiliate provider",
    "admin.f.actionUrl": "Primary action URL",
    "admin.f.storefront": "Front of business / storefront (opens the place page)",
    "admin.f.cover": "Cover image (shown on the browse cards)",
    "admin.f.gallery": "Gallery images",
    "admin.f.description": "Description",
    "admin.f.editorial": "Editorial summary",
    "admin.f.languages": "Language support",
    "admin.f.languagesPlaceholder": "English, Spanish",
    "admin.f.amenities": "Amenities / tags",
    "admin.f.amenitiesPlaceholder": "Outdoor seating, Wi-Fi, Parking",
    "admin.f.status": "Status",
    "admin.f.plan": "Plan",
    "admin.f.planHint": "Premium carries the verified badge, the six-photo gallery, the social links and the booking buttons. Basic keeps the name, category, address, hours, description and one photo.",
    "admin.f.featured": "Featured",
    "admin.f.editorPick": "Editor pick",
    "admin.f.localsKnow": "Locals know",
    "admin.f.verified": "Verified (Premium)",
    "admin.f.select": "— Select —",
    "admin.f.trendingPlaceholder": "1 = first in the rail",
    "admin.save": "Save",
    "admin.saving": "Saving…",
    "admin.saveAnother": "Save & add another",
    "admin.cancel": "Cancel",
    "admin.deleteConfirm": "Delete \"{name}\"?",
    "admin.errorSaving": "That couldn't be saved. Try again.",
    "admin.errorUpdating": "That couldn't be updated. Try again.",

    // --- Shared chrome & visitor surfaces ---
    "common.loading": "Loading…",
    "map.allPlaces": "All places",
    "map.resultsCount": "{count} places",
    "map.resultsCountOne": "1 place",
    "map.noPlaces": "No places here",
    "map.allFilters": "All filters",
    "map.zoomIn": "Zoom in",
    "map.zoomOut": "Zoom out",
    "map.myLocation": "My location",
    "map.showAll": "Show all places",
    "saved.title": "Saved Places",
    "saved.lead":
      "Your hand-picked list of Puerto Rico's best. Share it with your people — on Facebook, WhatsApp, anywhere.",
    "saved.share": "Share my list",
    "saved.count": "{count} saved",
    "saved.empty": "No saved places yet",
    "saved.emptyBody": "Tap the heart on any place to save it here.",
    "saved.browse": "Browse places",
    "saved.view": "View",
    "miLista.title": "My List",
    "miLista.tagline": "Your Puerto Rico, your way.",
    "miLista.lead": "Save places, organize plans and share experiences.",
    "miLista.statSaved": "saved",
    "miLista.statPlans": "plans",
    "miLista.statVisited": "visited",
    "miLista.createPlan": "Create a plan",
    "miLista.tabSaved": "Saved",
    "miLista.tabPlans": "My plans",
    "miLista.tabBookings": "Bookings",
    "miLista.tabJournal": "My journal",
    "miLista.search": "Search place, area or note…",
    "miLista.sortLabel": "Sort",
    "miLista.sortRecent": "Recently saved",
    "miLista.sortName": "Name A–Z",
    "miLista.sortArea": "Municipality A–Z",
    "miLista.sortCategory": "Category",
    "miLista.sortVisited": "Recently visited",
    "miLista.filterAll": "All",
    "miLista.filterTodo": "To visit",
    "miLista.filterVisited": "Visited",
    "miLista.filterOpen": "Open now",
    "miLista.filterArea": "Municipality",
    "miLista.allAreas": "All municipalities",
    "miLista.addToPlan": "Add to plan",
    "miLista.viewPlace": "View place",
    "miLista.viewExperience": "View experience",
    "miLista.book": "Book",
    "miLista.moreActions": "More actions",
    "miLista.openProfile": "View full profile",
    "miLista.share": "Share",
    "miLista.markVisited": "Mark as visited",
    "miLista.unmarkVisited": "Remove from visited",
    "miLista.addNote": "Add note",
    "miLista.editNote": "Edit note",
    "miLista.moveToCollection": "Move to collection",
    "miLista.removeSaved": "Remove from saved",
    "miLista.removeTitle": "Remove this place from your list?",
    "miLista.removeBody": "It stays in your plans and in your journal.",
    "miLista.cancel": "Cancel",
    "miLista.remove": "Remove",
    "miLista.visited": "Visited",
    "miLista.save": "Save",
    "miLista.saveToList": "Save to my list",
    "miLista.alreadySaved": "Saved",
    "miLista.noMatches": "No matches found",
    "miLista.noMatchesBody": "Try a different search or filter.",
    "miLista.emptySaved": "No saved places yet.",
    "miLista.emptySavedBody": "Explore Puerto Rico and save the places that catch your eye.",
    "miLista.explore": "Explore places",
    "miLista.emptyPlans": "No plans yet.",
    "miLista.emptyPlansBody": "Create a collection or an itinerary from your saved places.",
    "miLista.emptyBookings": "No bookings yet.",
    "miLista.emptyBookingsBody": "Save bookable experiences and keep track of them here.",
    "miLista.emptyJournal": "Your journal is empty.",
    "miLista.emptyJournalBody": "Mark a place as visited and keep the memory.",
    "miLista.resultCount": "{count} results",
    "miLista.clearSearch": "Clear search",
    "miLista.yourPlans": "Your plans",
    "miLista.itinerary": "Itinerary",
    "miLista.collection": "Collection",
    "miLista.days": "days",
    "miLista.places": "places",
    "miLista.open": "Open",
    "miLista.planName": "Plan name",
    "miLista.planNamePlaceholder": "e.g. Weekend in San Juan",
    "miLista.planType": "Plan type",
    "miLista.typeCollection": "Simple collection",
    "miLista.typeItinerary": "Itinerary with days",
    "miLista.create": "Create",
    "miLista.planDays": "Days",
    "miLista.noStops": "No stops yet.",
    "miLista.addSavedPlace": "+ Add a saved place",
    "miLista.planDeviceNote": "Your plan is saved on this device. Share your list to send your saved places.",
    "miLista.removeStop": "Remove stop",
    "miLista.day": "Day",
    "miLista.tripPlan": "Trip plan",
    "miLista.choosePlan": "Where does it go?",
    "miLista.newCollection": "New collection",
    "miLista.collections": "Collections",
    "miLista.pendingBook": "Not yet booked",
    "miLista.linkVisited": "Link opened",
    "miLista.confirmed": "Confirmed",
    "miLista.completed": "Completed",
    "miLista.cancelled": "Cancelled",
    "miLista.addBookingDetails": "Add booking details",
    "miLista.bookingDetails": "Booking details",
    "miLista.provider": "Provider",
    "miLista.date": "Date",
    "miLista.guests": "Guests",
    "miLista.reference": "Confirmation number",
    "miLista.note": "Personal note",
    "miLista.openProvider": "Open at provider",
    "miLista.markCompleted": "Mark completed",
    "miLista.cancelBooking": "Cancel booking",
    "miLista.userRecorded": "Added by you",
    "miLista.bookingNote": "Bookings are completed with the provider. Here you only keep track.",
    "miLista.journalEntry": "Journal entry",
    "miLista.visitDate": "Visit date",
    "miLista.addToJournal": "Add to journal",
    "miLista.removeFromJournal": "Remove from journal",
    "miLista.yourNote": "Your note",
    "miLista.noNote": "No note",
    "beach.activities": "What you can do here",
    "beach.bestFor": "Best for",
    "beach.water": "Water",
    "beach.amenities": "Amenities",
    "beach.nearby": "While you're here",
    "beach.compare": "Quick compare",
    "beach.compareSub": "Every beach side by side — swipe the table sideways on a phone.",
    "beach.col.beach": "Beach",
    "beach.col.area": "Area / District",
    "beach.col.coords": "Coordinates",
    "beach.col.bestFor": "Best for",
    "beach.col.water": "Water condition",
    "filter.title": "Advanced search",
    "filter.lead": "Pick a category, then the type of place inside it. Then a neighborhood.",
    "filter.category": "Category",
    "filter.anyCategory": "Any category",
    "filter.typeIn": "Type in {category}",
    "filter.allIn": "All {category}",
    "filter.neighborhood": "Neighborhood",
    "filter.allSanJuan": "All San Juan",
    "filter.reset": "Reset selections",
    "filter.hint":
      "The next step narrows the category to one of its types — from Chinchorros & Kiosks to Seafood and Cafés & Specialty Coffee.",
    "notFound.place": "Place not found",
    "notFound.placeBody": "This link doesn't match a place on Ya Tú Sabes yet.",
    "notFound.browse": "Browse places",
    "notFound.page": "Page not found",
    "notFound.pageBody": "We couldn't find \"{path}\" on Ya Tú Sabes. The link may be old or mistyped.",
    "notFound.pageBodyGeneric": "We couldn't find that page on Ya Tú Sabes. The link may be old or mistyped.",
    "notFound.home": "Back to home",
    "notFound.adminNote": "Admin note: no route or business matches this path.",
    "notFound.story": "Story not found",
    "detail.comingSoon": "Coming soon",
    "home.comingSoonIn": "Coming soon in {category}",
    "events.kicker": "What's happening",
    "events.title": "Events",
    "events.lead": "Things to do across Puerto Rico — live music, markets, culture, and more.",
    "events.calendar": "Calendar",
    "events.calendarTitle": "Events calendar",
    "events.calendarEmpty": "Nothing on the calendar for this date.",
    "services.claim": "Claim this spot →",
    "services.comingSoonBody":
      "The island's services, all in one place. These pages are open and waiting for the people who run them — claim yours and put yourself on the map.",
  },
  es: {
    "nav.explore": "Explorar",
    "nav.map": "Mapa",
    "nav.events": "Eventos",
    "nav.saved": "Guardados",
    "nav.planner": "Mi lista",
    "nav.magazine": "Revista",
    "nav.faq": "Revista",
    "nav.tagline": "La guía local de Puerto Rico",
    "tools.title": "Herramientas del sitio",
    "tools.appearance": "Apariencia",
    "tools.light": "Claro",
    "tools.dark": "Oscuro",
    "tools.language": "Idioma",
    "gate.kicker": "Bienvenido",
    "gate.title": "Elige tu idioma",
    "gate.sub": "Puedes cambiarlo cuando quieras desde el pie de página.",
    "menu.open": "Abrir menú",
    "menu.close": "Cerrar menú",
    "menu.browse": "Explorar",
    "menu.categories": "Categorías",
    "menu.neighborhoods": "Barrios",
    "menu.allNeighborhoods": "Ver todos en el mapa",
    "menu.forBusiness": "Para negocios",
    "menu.more": "Más",
    "menu.ownerTools": "Mi negocio",
    "menu.claim": "Reclama tu negocio",
    "menu.dashboard": "Panel del negocio",
    "menu.adDashboard": "Campañas de anuncios",
    "menu.admin": "Admin",
    "search.placeholder": "Buscar lugares, comida, experiencias...",
    "search.placeholderShort": "Busca en San Juan...",
    "search.clear": "Limpiar",
    "search.submit": "Buscar",
    "hero.kicker": "Puerto Rico, más allá de la postal",
    "hero.line1": "Mira más de",
    "hero.line2": "Puerto Rico.",
    "hero.blurb": "Lugares locales. Buena comida. Experiencias reales. Mira otro lado de la isla.",
    "hero.tags": "Comida · Cultura · Lugares · Experiencias",
    "experiences.noMatch": "Ninguna experiencia coincide con tu búsqueda o filtros.",
    "experiences.seeAll": "Ver todas: {count}",
    "hero.places": "{count} lugares locales por explorar",
    "hero.placeOne": "1 lugar local por explorar",
    "browse.gastronomy": "Comer",
    "browse.nightlife": "Beber",
    "browse.shop": "Comprar",
    "browse.do": "Hacer",
    "browse.services": "Servicios",
    "browse.stays": "Estancias",
    "browse.auto": "Alquiler de autos",
    "browse.jobs": "Empleos en Puerto Rico",
    "browse.filters": "Filtros",
    "browse.showing": "Mostrando {category} · Limpiar",
    "browse.clearFilters": "Limpiar filtros",
    "browse.mood": "Empieza por el ánimo, no por la categoría.",
    "browse.byCategory": "Explorar por categoría",
    "categoryHint.gastronomy": "Lugares para comer y beber",
    "categoryHint.nightlife": "Bares, clubes y música en vivo",
    "categoryHint.shop": "Boutiques y productos locales",
    "categoryHint.do": "Tours, excursiones y actividades",
    "categoryHint.services": "Servicios locales, bienestar y cuidado personal",
    "home.neighborhoodGuide": "Guía de barrios",
    "home.rightNowKicker": "Ahora mismo",
    "home.openInPuertoRico": "Abierto en Puerto Rico",
    "home.openInPuertoRicoSub": "Mira rápidamente qué lugares están abiertos ahora, según sus horarios publicados.",
    "home.trendingTitle": "Lo que está pasando",
    "home.trendingSub": "Lo que se mueve en Puerto Rico",
    "home.chinchorrosTitle": "Chinchorros y kioscos",
    "home.chinchorrosSub": "Kioscos de carretera, parrillas al aire libre y comida puertorriqueña.",
    "home.localPicksTitle": "Lugares de aquí",
    "home.localPicksSub": "Lugares locales que vale la pena conocer",
    "home.viewsTitle": "Azoteas y vistas",
    "home.viewsSub": "Vistas, azoteas y lugares para quedarse un rato",
    "home.foodTitle": "Comida y bebida",
    "home.foodSub": "Comida, café y lugares para quedarse un rato",
    "home.cultureTitle": "Puerto Rico de cerca",
    "home.cultureSub": "Cultura, lugares e historias que vale la pena conocer",
    "home.experiencesTitle": "Qué hacer",
    "home.experiencesSub": "Experiencias más allá de la postal",
    "home.collectionsTitle": "Por aquí",
    "home.collectionsSub": "Lugares, barrios y rincones que vale la pena explorar.",
    "home.loadError": "No pudimos cargar la guía en este momento. Actualiza la página para intentarlo de nuevo.",
    "nav.primary": "Navegación principal",
    "browse.categories": "Explorar categorías",
    "carousel.previous": "Lugares anteriores",
    "carousel.next": "Lugares siguientes",
    "services.title": "Servicios locales",
    "services.noMatch": "Ningún servicio coincide con esos filtros.",
    "services.blurb": "Explora servicios locales y encuentra negocios en la zona.",
    "category.noStays": "Todavía no hay alojamientos disponibles.",
    "category.noMatch": "Ningún lugar coincide con esos filtros.",
    "events.thisWeek": "Esta semana",
    "events.nextSevenDays": "Lo que viene durante los próximos siete días.",
    "events.openCalendar": "Abrir calendario",
    "events.comingUp": "Próximamente",
    "events.islandCalendar": "Todo lo demás en el calendario de la isla.",
    "category.more": "Más de {category}",
    "guide.neighborhoodKicker": "Ya Tú Sabes · Guía de barrios",
    "guide.openMap": "Abrir el mapa",
    "guide.localPlaces": "lugares locales",
    "guide.localGuide": "Guía local de Puerto Rico",
    "guide.exploreMap": "Explorar el mapa",
    "guide.places": "lugares",
    "guide.loading": "Cargando la guía local…",
    "guide.moreComing": "Estamos añadiendo más lugares locales.",
    "guide.widerArea": "Usa el mapa para explorar los alrededores.",
    "guide.picked": "Selección para esta guía",
    "guide.worthKnowing": "Lugares que vale la pena conocer",
    "guide.picks": "selecciones",
    "guide.placesToExplore": "Lugares para explorar",
    "guide.explore": "Explorar",
    "guide.category.restaurants": "Restaurantes",
    "guide.category.bars-nightlife": "Bares y vida nocturna",
    "guide.category.things-to-do": "Qué hacer",
    "guide.category.beaches": "Playas",
    "guide.category.shopping": "Compras",
    "guide.category.culture": "Cultura",
    "guide.category.services": "Servicios",
    "rail.viator": "Encontrado en Tripadvisor",
    "rail.foundOn": "Encontrado en",
    "rail.viatorSub": "Los tours, cruceros y aventuras que más reservan los viajeros — reservados de forma segura con nuestro socio de reservas",
    "rail.trending": "Lo más popular en Puerto Rico",
    "rail.locals": "Favoritos de los locales",
    "rail.neighborhoods": "Explora por barrio",
    "rail.chinchorros": "Chinchorros y Kioscos",
    "rail.chinchorrosSub": "Kioscos de carretera, parrillas al aire libre y cocinas criollas sin pretensiones.",
    "rail.eatdrink": "Gastronomía",
    "rail.vegan": "Vegano y Vegetariano",
    "rail.culture": "Cultura e Historia",
    "rail.experiences": "Experiencias",
    "rail.offbeaten": "Fuera del camino trillado",
    "rail.offbeatenSub": "Las calas, los miradores y las cocinas pequeñas que casi nadie llega a ver.",
    "rail.rooftops": "Azoteas y Vistas",
    "rail.beachesSub": "Calas escondidas y pozas de agua salada",
    "results.one": "1 resultado",
    "results.many": "{count} resultados",
    "results.clear": "Limpiar",
    "results.none": "Ningún lugar coincide con tu búsqueda o filtros.",
    "nav.all": "TODOS",
    "nearMe.title": "Cerca de mí",
    "nearMe.hint": "Mira primero lo que tienes más cerca",
    "nearMe.locating": "Buscando tu ubicación…",
    "nearMe.active": "Mostrando primero los lugares más cercanos a ti",
    "nearMe.error": "No pudimos leer tu ubicación — permítela en tu navegador e inténtalo otra vez.",
    "nearMe.unavailable": "Este dispositivo no puede compartir su ubicación.",
    "nearMe.results": "{count} formas de vivir Puerto Rico",
    "rail.nearYou": "Cerca de ti",
    "map.whereAmI": "¿Dónde estoy?",
    "map.locating": "Buscando…",
    "map.onTheMap": "En el mapa",
    "map.tapToExplore": "Toca para explorar",
    "map.exploring": "Explorando el mapa",
    "map.exploreSub": "Barrios · Comida · Playas",
    "map.nearMeCta": "¿Qué hay cerca de mí?",
    "map.viewOnMap": "Ver en el mapa",
    "map.moreInfo": "Más información",
    "map.tapToCollapse": "Toca para cerrar",
    "detail.save": "Guardar",
    "detail.share": "Compartir",
    "detail.directions": "Cómo llegar",
    "detail.call": "Llamar",
    "detail.social": "Redes",
    "social.pending": "Aún no compartido",
    "detail.essential": "Información esencial",
    "detail.location": "Ubicación",
    "detail.beach": "Guía de playa",
    "detail.about": "Acerca de",
    "detail.community": "Experiencias de la comunidad y consejos locales",
    "detail.noStories": "Aún no hay historias. Sé el primero en compartir.",
    "detail.price": "Precio",
    "detail.hours": "Horario",
    "hours.today": "Hoy",
    "hours.open": "Abierto ahora",
    "hours.closed": "Cerrado",
    "hours.opensAt": "abre a las {time}",
    "hours.opensOn": "abre {day} a las {time}",
    "hours.opensTomorrow": "abre mañana a las {time}",
    "hours.closesAt": "cierra a las {time}",
    "card.open": "Abierto",
    "card.closingSoon": "Cierra pronto",
    "card.closed": "Cerrado",
    "card.openingSoon": "Abre pronto",
    "card.closesAt": "Cierra {time}",
    "card.opensAt": "Abre {time}",
    "card.opensTomorrow": "Mañana {time}",
    "card.opensOn": "{day} {time}",
    "hours.allDays": "Todos los días",
    "hours.hideDays": "Ocultar días",
    "hours.daily": "Todos los días",
    "hours.closedDay": "Cerrado",
    "hours.editTitle": "Horario semanal",
    "hours.editHint": "Marca los días que abres. Lo que quede cerrado se lee como cerrado; la píldora de abajo es justo lo que ve el visitante.",
    "hours.lineLabel": "O escribe el horario",
    "hours.lineHint": "Se llena con los días de arriba. Úsalo solo cuando el horario es irregular.",
    "hours.preview": "Cómo se lee",
    "hours.applyAll": "Usar el horario del {day} todos los días",
    "hours.aiTitle": "Horario desde una frase",
    "hours.aiHint": "Escribe el horario como lo dirías — en inglés o español, sin formalidades.",
    "hours.aiPlaceholder": "ej. Mar–Dom 11am–9pm, cerrado los lunes",
    "hours.aiButton": "Llenar la semana",
    "hours.aiWorking": "Llenando…",
    "hours.aiError": "No pudimos leerlo. Intenta escribir el horario de otra forma.",
    "detail.address": "Dirección",
    "detail.phone": "Teléfono",
    "detail.languages": "Idiomas",
    "detail.web": "Web",
    "detail.amenities": "Servicios",
    "detail.visitWebsite": "Visitar el sitio web",
    "detail.submit": "Compartir",
    "detail.submitting": "Enviando…",
    "detail.yourName": "TU NOMBRE",
    "detail.tipPlaceholder": "Comparte tu experiencia o un consejo local…",
    "detail.bookViator": "Reservar en Viator",
    "detail.aboutExperience": "Sobre esta experiencia",
    "detail.translationPending": "La descripción completa en español está en preparación. Consulta la página de reserva para ver todos los detalles antes de reservar.",
    "detail.included": "Qué incluye",
    "detail.goodToKnow": "Información útil",
    "detail.duration": "Duración",
    "detail.from": "Desde",
    "detail.meeting": "Encuentro",
    "detail.cancellation": "Cancelación",
    "detail.availability": "Disponibilidad",
    "detail.availabilityText": "Las fechas, horarios y precios actualizados se muestran en Viator al reservar.",
    "detail.bookedVia": "Reservado con",
    "detail.perPerson": "por persona",
    "detail.reviews": "reseñas",
    "detail.handledBy": "El pago lo procesa Viator",
    "detail.stayNote": "Sigues en Ya Tú Sabes PR mientras exploras — el pago y la confirmación los maneja Viator (TripAdvisor) de forma segura, y esta página permanece abierta.",
    "detail.experienceNotFound": "Experiencia no encontrada",
    "detail.experienceGone": "Esta experiencia reservable ya no está listada.",
    "detail.back": "Atrás",
    "nav.business": "Para negocios",
    "claim.owner": "¿Es tuyo este negocio?",
    "claim.blurb": "¿Es tuyo este negocio? Reclámalo para mantener al día las fotos, horarios y enlaces.",
    "claim.cta": "Reclamar ahora",
    "claim.bannerTitle": "¿Es tu negocio? Reclama tu página.",
    "claim.bannerSub": "Administra fotos, horarios y datos. Plan fundador: $100 el primer año.",
    "claim.bannerCta": "Reclamar",
    "claim.managed": "Administrado por su dueño",
    "claim.mine": "Tú administras este listado",
    "claim.dashboard": "Abrir panel del negocio",
    "claim.title": "Reclama este negocio",
    "claim.intro": "La reclamación del listado cuesta $100 el primer año. Envía tus datos para una revisión manual; este formulario no te cobra. Nos comunicaremos contigo para verificar el negocio y explicarte el próximo paso.",
    "claim.name": "Tu nombre",
    "claim.email": "Correo",
    "claim.phone": "Teléfono",
    "claim.role": "Tu rol en el negocio",
    "claim.link": "Sitio web o red social",
    "claim.note": "Algo que nos ayude a confirmarlo",
    "claim.submit": "Enviar reclamo",
    "claim.sending": "Enviando…",
    "claim.sent": "Reclamo recibido",
    "claim.sentBlurb": "Revisamos los reclamos en un par de días. Puedes seguirlo desde tu panel de negocio.",
    "claim.sentGuest": "Enviamos tu reclamo al equipo para revisión. Te escribiremos por correo. No necesitas cuenta.",
    "claim.review": "Tu reclamo está en revisión",
    "claim.reviewBlurb": "Te escribimos en cuanto se apruebe.",
    "claim.signIn": "Inicia sesión para reclamar",
    "claim.signInBlurb": "Los reclamos van ligados a tu cuenta para que puedas administrar el listado después.",
    "claim.error": "No se pudo enviar. Inténtalo otra vez.",
    "claim.required": "Agrega tu nombre, correo y teléfono.",
    "share.title": "Comparte este hallazgo",
    "share.subtitle": "Envíalo a un amigo — cada enlace abre aquí mismo.",
    "share.native": "Compartir desde tu teléfono",
    "share.copy": "Copiar enlace",
    "share.copied": "Enlace copiado",
    "share.scan": "O deja que alguien escanee este código: abre aquí mismo.",
    "share.listTitle": "Mi lista de Puerto Rico",
    "share.listCount": "{count} guardados",
    "share.listIntro": "Guardado en Ya Tú Sabes PR, la guía local de la isla:",
    "share.listOutro": "Arma tu propia lista:",
    "share.copyList": "Copiar lista",
    "share.copiedList": "Lista copiada",
    "story.back": "Todas las historias",
    "story.by": "Por",
    "story.read": "{count} min de lectura",
    "story.places": "Lugares en esta historia",
    "faq.kicker": "Ya Tú Sabes · Bueno saber",
    "faq.title": "Puerto Rico, resuelto.",
    "faq.blurb":
      "Respuestas directas a lo que más preguntan los viajeros: cómo moverte, dinero, playas, comida, seguridad y esos detalles que nadie te cuenta.",
    "faq.searchPlaceholder": "Busca preguntas…",
    "faq.all": "Todas",
    "faq.loading": "Cargando preguntas…",
    "faq.empty": "Ninguna pregunta coincide con esa búsqueda.",
    "faq.magazine": "De la revista",
    "faq.magazineSub": "Lecturas más largas desde la isla: historia, comida y mirada local.",
    "blog.kicker": "La revista de Ya Tú Sabes",
    "blog.brand": "Revista",
    "blog.tagline":
      "Lo que se está moviendo en la isla ahora mismo: barrios que reviven, aperturas nuevas y la gente detrás. Y justo debajo, las respuestas que la gente busca.",
    "blog.feature": "El reportaje",
    "blog.latest": "Lo último",
    "blog.readStory": "Leer la historia",
    "blog.faqJump": "Preguntas",
    "nav.about": "Nosotros",
    "nav.contact": "Contacto",
    "footer.tagline": "La guía local de Puerto Rico — barrios, comida, cultura y experiencias.",
    "footer.made": "Hecho en Puerto Rico.",
    "nav.privacy": "Política de Privacidad",
    "nav.terms": "Términos y Condiciones",
    "legal.updated": "Última actualización",
    "about.kicker": "Sobre Ya Tú Sabes PR",
    "about.title": "Una guía viva de Puerto Rico.",
    "about.lead":
      "Ya Tú Sabes PR es una guía local gratuita e independiente, creada en Puerto Rico para conectar a residentes y visitantes con los lugares, las personas, la cultura, los eventos, los negocios y las experiencias que le dan vida a la isla.",
    "about.founderTitle": "Por qué existe esto",
    "about.founderHeadline": "Me mudé a Río Piedras para verlo por mí mismo.",
    "about.founder":
      "Cuando me mudé de Virginia a Puerto Rico, decidí convertir una decisión en un experimento: me mudé a Río Piedras. Mucha gente me advirtió que no lo hiciera. Me dijeron que el barrio era horrible, que no había nada que hacer y que estaría mejor en un lugar más conocido o más preparado para los visitantes. Quise vivirlo por mi cuenta, en vez de dejar que la reputación de otras personas decidiera lo que podía encontrar. Lo que encontré fue casi lo contrario. Río Piedras tiene comida con sabor y personalidad, servicios útiles para el día a día, negocios independientes, gente acogedora, cultura y esos encuentros inesperados que hacen que un lugar se sienta vivo. También tiene retos reales y momentos impredecibles; fingir lo contrario no sería honesto. Pero la incertidumbre existe en ciudades y comunidades de todo el mundo. Es una razón para estar atento, conocer la zona y tomar decisiones sensatas—no para descartar un barrio entero ni concluir que todo el mundo debería quedarse en casa. Mi experiencia me hizo preguntarme por qué tanta atención se concentra en un grupo limitado de destinos conocidos, mientras otras comunidades con tanto que ofrecer siguen siendo difíciles de encontrar. Creo que Río Piedras y barrios como este merecen ser vistos por lo que son: sus servicios, su oferta cotidiana, su comida, su creatividad, su hospitalidad y su gente—no como una nota al margen ni como una advertencia. Ya Tú Sabes PR nació de esa convicción. Quiero ayudar a cerrar las brechas en la promoción turística y en el acceso a información local, comenzando en San Juan y las comunidades cercanas, para que residentes y visitantes encuentren más de lo que ya existe y los negocios locales tengan una oportunidad más justa de ser encontrados.",
    "about.founderName": "Fundador y editor, Ya Tú Sabes PR",
    "about.whatTitle": "Qué es esto",
    "about.ideaLabel": "La idea",
    "about.audienceLabel": "Para quién es",
    "about.builtHereLabel": "Hecho aquí",
    "about.statPlaces": "Lugares",
    "about.statEvents": "Eventos",
    "about.statCulture": "Cultura",
    "about.statBook": "Reservar",
    "about.what":
      "Estamos construyendo un puente gratuito y fácil de usar entre las personas y los lugares que las rodean: negocios de barrio, restaurantes, tiendas, mercados, espacios culturales, vida nocturna, eventos, lugares al aire libre y experiencias reservables. Queremos que los residentes encuentren algo nuevo cerca de casa y que los visitantes conozcan más allá de las paradas más famosas. Ya Tú Sabes PR es una startup y la guía es gratis. Todavía no hemos recibido donaciones ni financiación externa. Nuestros socios de reservas, como Viator, Tripadvisor y GetYourGuide, pueden generar comisiones por referidos cuando alguien reserva a través de sus enlaces, pero el apoyo de la comunidad es importante para mejorar la cobertura, mantener la plataforma y destacar más negocios e historias locales.",
    "about.whoTitle": "Para quién es",
    "about.who":
      "Para quienes planean su primer viaje. Para quienes vuelven y quieren ir más allá de la postal. Para los locales que buscan lo que acaba de abrir a la vuelta de la esquina. Y para los dueños de los negocios en estas páginas: reclama tu listado y te ayudamos a mantener horarios, fotos y enlaces al día.",
    "about.teamTitle": "Quién lo hace",
    "about.team":
      "Ya Tú Sabes PR es una startup independiente creada en Puerto Rico. Trabajamos para cerrar brechas en la promoción del turismo local, los negocios de barrio y las experiencias culturales—comenzando en San Juan y las comunidades cercanas, y creciendo según nuestros recursos lo permitan. La guía seguirá siendo gratuita para residentes y visitantes. En esta etapa no hay financiación externa ni un fondo de donaciones detrás del sitio; algunos enlaces de reservas pueden generar comisiones por referidos. Las donaciones y el apoyo de la comunidad pueden ayudarnos a mantener la guía accesible y ampliar los lugares y las voces que representa.",
    "about.supportLabel": "Ayúdanos a crecer",
    "about.supportTitle": "Ayuda a mantener esta guía gratuita e independiente.",
    "about.supportBody": "Estamos construyendo este proyecto por etapas, sin financiación externa ni un fondo de donaciones detrás del sitio. Si esta guía te ayudó a encontrar un lugar o planificar un día, escríbenos para conocer cómo apoyar la próxima etapa.",
    "about.supportButton": "Apoyar el proyecto",
    "about.contactTitle": "Habla con nosotros",
    "about.contact": "¿Preguntas, correcciones o un lugar que debemos conocer? Escríbenos — los leemos todos.",
    "contact.kicker": "Contacto · Ya Tú Sabes PR",
    "contact.title": "Di hola.",
    "contact.blurb":
      "Preguntas, correcciones, un lugar que debemos conocer o un listado que quieras reclamar: envíanos una nota y llega directo a nuestra bandeja en Puerto Rico.",
    "contact.name": "Tu nombre",
    "contact.email": "Tu correo",
    "contact.message": "Tu mensaje",
    "contact.messagePlaceholder": "Cuéntanos qué tienes en mente…",
    "contact.send": "Enviar mensaje",
    "contact.sending": "Enviando…",
    "contact.successTitle": "Mensaje enviado",
    "contact.success": "Gracias — tu nota va en camino. Normalmente respondemos en un par de días.",
    "contact.another": "Enviar otro mensaje",
    "contact.error": "No se pudo enviar. Inténtalo otra vez.",
    "contact.required": "Completa tu nombre, correo y mensaje.",
    "contact.directTitle": "Escríbenos directamente",
    "contact.directNote":
      "¿Prefieres tu propio correo? Lo lee el mismo equipo pequeño — normalmente en un par de días.",
    "contact.basedIn": "Escrito, fotografiado y mantenido en Puerto Rico",
    "nav.advertise": "Anúnciate",
    "ads.label": "Publicidad",
    "ads.cta": "Anúnciate aquí",
    "ads.blurb": "Pon tu negocio frente a quienes planifican su próxima parada en Puerto Rico.",
    "ads.available": "Espacio disponible",
    "ads.seeSpaces": "Ver los espacios",
    "ads.sponsored": "Patrocinado",
    "ads.visit": "Visitar sitio",
    "advertise.kicker": "Publicidad en Ya Tú Sabes PR",
    "advertise.title": "Anúnciate aquí.",
    "advertise.lead":
      "Una isla, una guía. Nuestros espacios viven donde la gente elige dónde comer, dormir y salir — y se quedan discretos a propósito, para que tu nombre se lea y no se salte.",
    "advertise.howTitle": "Cómo funciona",
    "advertise.how1": "Elige un espacio. Cada precio de abajo es por mes y por anunciante.",
    "advertise.how2": "Un solo socio por espacio a la vez — ningún competidor comparte tu lugar.",
    "advertise.how3": "Lo montamos, lo mantenemos vivo y te enviamos los números al cerrar el mes.",
    "advertise.spacesTitle": "Activos en el sitio ahora",
    "advertise.requestTitle": "A petición",
    "advertise.slotsLabel": "plazas",
    "advertise.month": "mes",
    "advertise.boardTitle": "La cartelera completa",
    "advertise.boardNote":
      "{slots} plazas mensuales en {live} espacios activos — {total} al mes con todo vendido. La mayoría empieza con un espacio y renueva.",
    "advertise.formTitle": "Pregunta por un espacio",
    "advertise.formBlurb":
      "Cuéntanos del negocio y del espacio que buscas. Te respondemos con disponibilidad, fechas y un montaje de tu anuncio.",
    "advertise.business": "Nombre del negocio",
    "advertise.space": "Espacio que te interesa",
    "advertise.note": "Qué tienes en mente",
    "advertise.notePlaceholder": "Cuéntanos del negocio, las fechas y el presupuesto con el que trabajas…",
    "advertise.send": "Enviar consulta",
    "advertise.sending": "Enviando…",
    "advertise.sentTitle": "Consulta enviada",
    "advertise.sent": "Gracias — ya tenemos tu nota y te escribimos con la disponibilidad y un montaje del espacio.",
    "advertise.another": "Enviar otra consulta",
    "advertise.how4":
      "Paga con tarjeta. Stripe procesa el pago, un mes a la vez, y tu espacio sale al aire en cuanto se acredita.",
    "advertise.dashCta": "Abrir el panel del anunciante",
    "advertise.askCta": "Escríbenos",
    "advertise.goalLabel": "Nuestra meta",
    "advertise.payNote":
      "Los pagos con tarjeta pasan por Stripe y cubren un mes en un espacio. Nada se renueva solo, y puedes cambiar el arte cuando quieras.",
    "adDash.navLink": "Panel del anunciante",
    "adDash.kicker": "Panel del anunciante",
    "adDash.title": "Tus espacios publicitarios.",
    "adDash.lead":
      "Reserva un espacio, sube tu arte, paga el mes que quieres correr y cambia la pieza cuando quieras. Tu espacio sale al aire en cuanto el pago se acredita.",
    "adDash.signedIn": "Sesión iniciada como {email}",
    "adDash.backToRates": "Ver los espacios y precios",
    "adDash.yoursTitle": "Tus campañas",
    "adDash.empty": "Todavía no tienes nada reservado. Elige un espacio abajo, sube tu arte y paga el mes que quieres correr.",
    "adDash.newTitle": "Reserva un espacio",
    "adDash.newBlurb":
      "Un espacio, un mes, un anunciante. Puedes cambiar la pieza cuantas veces quieras mientras corre tu mes.",
    "adDash.business": "Nombre del negocio",
    "adDash.space": "Espacio",
    "adDash.headline": "Titular",
    "adDash.headlinePlaceholder": "¿Qué debe leer la gente primero?",
    "adDash.line": "Una línea de apoyo",
    "adDash.linePlaceholder": "Opcional — dónde estás o por qué te conocen",
    "adDash.link": "A dónde lleva el anuncio",
    "adDash.art": "Arte",
    "adDash.artReady": "Arte subido y listo para correr.",
    "adDash.replace": "Reemplazar",
    "adDash.removeArt": "Quitar arte",
    "adDash.upload": "Subir arte",
    "adDash.uploading": "Subiendo…",
    "adDash.uploadError": "No se pudo subir esa imagen. Prueba con PNG o JPG.",
    "adDash.artHint": "PNG, JPG o WebP. El arte se guarda de forma pública — todo el que visita el sitio lo ve.",
    "adDash.spacePrice": "{price} al mes en este espacio, {size}.",
    "adDash.create": "Guardar este anuncio",
    "adDash.saving": "Guardando…",
    "adDash.saveChanges": "Guardar cambios",
    "adDash.cancel": "Cancelar",
    "adDash.edit": "Editar",
    "adDash.delete": "Eliminar",
    "adDash.pay": "Pagar {price} por un mes",
    "adDash.paying": "Abriendo el pago…",
    "adDash.runsUntil": "corre hasta {date}",
    "adDash.live": "Pago recibido — tu espacio está al aire.",
    "adDash.pending": "Ese pago todavía no se ha acreditado. Si pagaste, el espacio se activa en un minuto o dos.",
    "adDash.cancelled": "Pago cancelado — no se cobró nada.",
    "adDash.required": "Agrega el nombre del negocio, un titular, una dirección web y tu arte antes de guardar.",
    "adDash.saveError": "No se pudo guardar. Inténtalo otra vez.",
    "adDash.payError": "No se pudo iniciar el pago. Inténtalo otra vez.",
    "adDash.status.Draft": "Borrador",
    "adDash.status.Awaiting payment": "Esperando pago",
    "adDash.status.Active": "Al aire",
    "adDash.status.Paused": "En pausa",
    "adDash.status.Expired": "Terminado",
    "join.kicker": "Para negocios y experiencias",
    "join.title": "Pon tu lugar en la guía de la isla.",
    "join.lead":
      "Ya Tú Sabes PR es donde los viajeros planean Puerto Rico y donde los locales buscan lo que acaba de abrir. Únete a la guía y te construimos una página que la gente encuentra de verdad: en el mapa, en los carruseles y en la búsqueda.",
    "join.ctaAdd": "Agrega tu negocio",
    "join.ctaExplore": "Ver la guía",
    "join.fact1": "Se lee en inglés y español",
    "join.fact2": "En el mapa, en los carruseles y en la búsqueda",
    "join.fact3": "Horarios, fotos y enlaces que tú mantienes al día",
    "join.pathsTitle": "Dos formas de entrar",
    "join.pathsBlurb": "Elige la que va con lo que tienes — lo único que cambia es el precio.",
    "join.localTitle": "Bares, restaurantes, tiendas y servicios",
    "join.localBlurb":
      "Chinchorros, cafés, panaderías, bares, boutiques, galerías, hospedajes y servicios locales — donde entra la gente.",
    "join.freeTag": "Freemium",
    "join.freePrice": "Gratis",
    "join.freeBlurb": "Una página real en la guía, sin costo, por el tiempo que quieras.",
    "join.free1": "Nombre, tipo, barrio, horario y teléfono",
    "join.free2": "Una foto y una descripción",
    "join.free3": "Editable por ti desde tu panel",
    "join.subTag": "Suscripción",
    "join.perMonth": "/ mes",
    "join.subBlurb": "Para los negocios que quieren destacarse y recibir reservas.",
    "join.sub1": "Insignia verificada en tu tarjeta, tu página y el pin del mapa",
    "join.sub2": "Galería completa de fotos, redes y WhatsApp",
    "join.sub3": "Botón de Reservar, Ordenar o Pedir en tu página",
    "join.subYearly": "O {yearly} al año.",
    "join.expTitle": "Experiencias, tours y actividades",
    "join.expBlurb":
      "Guías, charters, degustaciones, clases de surf, recorridos de comida — cualquier cosa que ofrezcas y los viajeros reserven.",
    "join.flatTag": "Tarifa fija",
    "join.flatBlurb": "Una tarifa mensual fija. Sin comisión por lo que vendas.",
    "join.flat1": "Tu propia página, con precio y enlace a tu sistema de reservas",
    "join.flat2": "Destacada en el carrusel de experiencias y en el mapa",
    "join.commTag": "Comisión",
    "join.commPrice": "Comisión por reserva",
    "join.commBlurb":
      "La tasa que tu empresa ya ofrece a sus socios — acordamos los términos juntos y pagas solo cuando reservan.",
    "join.comm1": "Sin cuota mensual",
    "join.comm2": "Los viajeros reservan en el sistema que ya usas",
    "join.expNote":
      "En cualquier caso sigues vendiendo por tu propio sistema de reservas — nosotros te enviamos a los viajeros directo.",
    "join.stepsTitle": "Cómo funciona",
    "join.step1": "Envíanos tus datos",
    "join.step1Body": "Dos minutos, sin necesidad de cuenta.",
    "join.step2": "Construimos tu página",
    "join.step2Body":
      "La escribimos, agregamos tus fotos y te colocamos en el mapa — la apruebas antes de publicarla.",
    "join.step3": "Tú la manejas",
    "join.step3Body":
      "Horarios, fotos, enlaces y tu plan, editados desde tu panel y en vivo al instante.",
    "join.formTitle": "Agrega tu negocio o experiencia",
    "join.formBlurb": "Cuéntanos quién eres y nosotros seguimos desde ahí.",
    "join.bizName": "Nombre del negocio",
    "join.kind": "¿Qué vas a agregar?",
    "join.kindFood": "Restaurante, bar o café",
    "join.kindShop": "Tienda o boutique",
    "join.kindStay": "Hotel o hospedaje",
    "join.kindService": "Servicio local",
    "join.kindExperience": "Experiencia o tour",
    "join.kindOther": "Otra cosa",
    "join.area": "Barrio o pueblo",
    "join.contactName": "Tu nombre",
    "join.email": "Correo",
    "join.phone": "Teléfono",
    "join.link": "Sitio web o red social",
    "join.plan": "¿Cómo quieres entrar?",
    "join.planFree": "Freemium — listado gratis",
    "join.planSubscription": "Suscripción — plan mensual",
    "join.planExpFlat": "Experiencia — {price} al mes fijo",
    "join.planExpCommission": "Experiencia — comisión por reserva",
    "join.notes": "¿Algo que debamos saber?",
    "join.notesPlaceholder": "Cuéntanos del lugar, los horarios, la historia…",
    "join.submit": "Enviar mis datos",
    "join.sending": "Enviando…",
    "join.required": "Agrega el nombre de tu negocio, tu nombre y un correo.",
    "join.error": "No se pudo enviar. Inténtalo otra vez.",
    "join.sentTitle": "Recibido.",
    "join.sentBlurb":
      "Revisamos tus datos y te escribimos — normalmente en un par de días — con tu página y el siguiente paso.",
    "join.another": "Agregar otro negocio",
    "join.ownerTitle": "¿Ya estás en la guía?",
    "join.ownerBlurb":
      "Busca tu negocio en el sitio y reclámalo. Cuando confirmemos que es tuyo, la página llega a tu panel lista para editar.",
    "join.ownerCta": "Buscar mi negocio",
    "join.dashboardCta": "Panel del negocio",

    // --- Admin ---
    "admin.title": "YTS Admin",
    "admin.dashboard": "Panel",
    "admin.viewSite": "Ver el sitio →",
    "admin.adminsOnly": "Solo administradores",
    "admin.adminsOnlyBody": "Necesitas una cuenta de administrador para entrar aquí.",
    "admin.backHome": "Volver al inicio",
    "admin.tab.Listing": "Lugares",
    "admin.tab.Category": "Categorías",
    "admin.tab.Neighborhood": "Barrios",
    "admin.tab.Story": "Historias",
    "admin.tab.Viator": "Viator",
    "admin.tab.BusinessClaim": "Reclamos",
    "admin.tab.PlanUpgrade": "Solicitudes Premium",
    "admin.listings": "Lugares",
    "admin.new": "Nuevo",
    "admin.loading": "Cargando…",
    "admin.empty": "Aún no hay lugares.",
    "admin.noMatches": "Nada coincide con estos filtros.",
    "admin.shown": "{count} en pantalla",
    "admin.filter.all": "Todos",
    "admin.filter.experiences": "Experiencias",
    "admin.filter.beaches": "Playas",
    "admin.filter.services": "Servicios",
    "admin.filter.comingSoon": "Próximamente",
    "admin.searchPlaceholder": "Buscar por nombre…",
    "admin.allNeighborhoods": "Todos los barrios",
    "admin.badge.Published": "Publicado",
    "admin.badge.Draft": "Borrador",
    "admin.badge.Archived": "Archivado",
    "admin.badge.comingSoon": "Próximamente",
    "admin.plan.Free": "Gratis",
    "admin.plan.Premium": "Premium",
    "admin.edit": "Editar",
    "admin.view": "Ver",
    "admin.delete": "Eliminar",
    "admin.show": "Mostrar en el sitio",
    "admin.hide": "Ocultar del sitio",
    "admin.editListing": "Editar lugar",
    "admin.newListing": "Nuevo lugar",
    "admin.s.basic": "Datos básicos",
    "admin.s.beach": "Guía de playa",
    "admin.s.location": "Ubicación y contacto",
    "admin.s.hours": "Horario",
    "admin.s.social": "Redes sociales",
    "admin.s.action": "Acción principal y afiliados",
    "admin.s.media": "Imágenes",
    "admin.s.details": "Detalles y servicios",
    "admin.f.name": "Nombre",
    "admin.f.pageLink": "Enlace de la página",
    "admin.f.type": "Tipo",
    "admin.f.category": "Categoría",
    "admin.f.subcategory": "Subcategoría",
    "admin.f.neighborhood": "Barrio",
    "admin.f.trending": "Posición en tendencias",
    "admin.f.trendingHint":
      "Solo para un lugar destacado: su puesto en Lo más popular de Puerto Rico. Si lo dejas vacío, va detrás de los numerados.",
    "admin.f.coords": "Coordenadas / ubicación",
    "admin.f.coordsHint": "Pega coordenadas o un enlace de Google Maps directamente (ej. 18.4655, -66.1180)",
    "admin.f.parsed": "Detectado",
    "admin.f.address": "Dirección",
    "admin.f.phone": "Teléfono",
    "admin.f.website": "Sitio web",
    "admin.f.booking": "URL de reservas",
    "admin.f.whatsapp": "WhatsApp / enlace",
    "admin.f.instagram": "Instagram",
    "admin.f.facebook": "Facebook",
    "admin.f.tiktok": "TikTok",
    "admin.f.twitter": "X / Twitter",
    "admin.f.youtube": "YouTube",
    "admin.f.actionType": "Tipo de acción principal",
    "admin.f.affiliate": "Proveedor de afiliados",
    "admin.f.actionUrl": "URL de la acción principal",
    "admin.f.storefront": "Frente del negocio / fachada (abre la página del lugar)",
    "admin.f.cover": "Imagen de portada (se muestra en las tarjetas del sitio)",
    "admin.f.gallery": "Galería de imágenes",
    "admin.f.description": "Descripción",
    "admin.f.editorial": "Resumen editorial",
    "admin.f.languages": "Idiomas disponibles",
    "admin.f.languagesPlaceholder": "Inglés, Español",
    "admin.f.amenities": "Servicios / etiquetas",
    "admin.f.amenitiesPlaceholder": "Asientos al aire libre, Wi-Fi, Estacionamiento",
    "admin.f.status": "Estado",
    "admin.f.plan": "Plan",
    "admin.f.planHint":
      "Premium incluye la insignia verificada, la galería de seis fotos, las redes sociales y los botones de reserva. Básico conserva nombre, categoría, dirección, horario, descripción y una foto.",
    "admin.f.featured": "Destacado",
    "admin.f.editorPick": "Elección del editor",
    "admin.f.localsKnow": "Los locales lo saben",
    "admin.f.verified": "Verificado (Premium)",
    "admin.f.select": "— Selecciona —",
    "admin.f.trendingPlaceholder": "1 = primero en el carrusel",
    "admin.save": "Guardar",
    "admin.saving": "Guardando…",
    "admin.saveAnother": "Guardar y agregar otro",
    "admin.cancel": "Cancelar",
    "admin.deleteConfirm": "¿Eliminar \"{name}\"?",
    "admin.errorSaving": "No se pudo guardar. Inténtalo otra vez.",
    "admin.errorUpdating": "No se pudo actualizar. Inténtalo otra vez.",

    // --- Shared chrome & visitor surfaces ---
    "common.loading": "Cargando…",
    "map.allPlaces": "Todos los lugares",
    "map.resultsCount": "{count} lugares",
    "map.resultsCountOne": "1 lugar",
    "map.noPlaces": "No hay lugares aquí",
    "map.allFilters": "Todos los filtros",
    "map.zoomIn": "Acercar",
    "map.zoomOut": "Alejar",
    "map.myLocation": "Mi ubicación",
    "map.showAll": "Ver todos los lugares",
    "saved.title": "Lugares guardados",
    "planner.title": "Planificador",
    "saved.lead":
      "Tu lista escogida de lo mejor de Puerto Rico. Compártela con tu gente — por Facebook, WhatsApp, donde sea.",
    "saved.share": "Compartir mi lista",
    "saved.count": "{count} guardados",
    "saved.empty": "Aún no has guardado lugares",
    "saved.emptyBody": "Toca el corazón en cualquier lugar para guardarlo aquí.",
    "saved.browse": "Explorar lugares",
    "saved.view": "Ver",
    "miLista.title": "Mi Lista",
    "miLista.tagline": "Tu Puerto Rico, a tu manera.",
    "miLista.lead": "Guarda lugares, organiza planes y comparte experiencias.",
    "miLista.statSaved": "guardados",
    "miLista.statPlans": "planes",
    "miLista.statVisited": "visitados",
    "miLista.createPlan": "Crear un plan",
    "miLista.tabSaved": "Guardados",
    "miLista.tabPlans": "Mis planes",
    "miLista.tabBookings": "Reservas",
    "miLista.tabJournal": "Mi diario",
    "miLista.search": "Buscar lugar, área o nota…",
    "miLista.sortLabel": "Ordenar",
    "miLista.sortRecent": "Guardados recientes",
    "miLista.sortName": "Nombre A–Z",
    "miLista.sortArea": "Municipio A–Z",
    "miLista.sortCategory": "Categoría",
    "miLista.sortVisited": "Visitados recientes",
    "miLista.filterAll": "Todos",
    "miLista.filterTodo": "Por visitar",
    "miLista.filterVisited": "Visitados",
    "miLista.filterOpen": "Abierto ahora",
    "miLista.filterArea": "Municipio",
    "miLista.allAreas": "Todos los municipios",
    "miLista.addToPlan": "Añadir a plan",
    "miLista.viewPlace": "Ver lugar",
    "miLista.viewExperience": "Ver experiencia",
    "miLista.book": "Reservar",
    "miLista.moreActions": "Más acciones",
    "miLista.openProfile": "Ver perfil completo",
    "miLista.share": "Compartir",
    "miLista.markVisited": "Marcar como visitado",
    "miLista.unmarkVisited": "Quitar de visitados",
    "miLista.addNote": "Añadir nota",
    "miLista.editNote": "Editar nota",
    "miLista.moveToCollection": "Mover a colección",
    "miLista.removeSaved": "Eliminar de guardados",
    "miLista.removeTitle": "¿Quitar este lugar de tu lista?",
    "miLista.removeBody": "Seguirá en tus planes y en tu diario.",
    "miLista.cancel": "Cancelar",
    "miLista.remove": "Quitar",
    "miLista.visited": "Visitado",
    "miLista.save": "Guardar",
    "miLista.saveToList": "Guardar en mi lista",
    "miLista.alreadySaved": "Guardado",
    "miLista.noMatches": "No hay coincidencias",
    "miLista.noMatchesBody": "Prueba con otra búsqueda o filtro.",
    "miLista.emptySaved": "Aún no tienes lugares guardados.",
    "miLista.emptySavedBody": "Explora Puerto Rico y guarda los lugares que te interesen.",
    "miLista.explore": "Explorar lugares",
    "miLista.emptyPlans": "Aún no tienes planes.",
    "miLista.emptyPlansBody": "Crea una colección o un itinerario con tus lugares guardados.",
    "miLista.emptyBookings": "No hay reservas todavía.",
    "miLista.emptyBookingsBody": "Guarda experiencias que se puedan reservar y organízalas aquí.",
    "miLista.emptyJournal": "Tu diario está en blanco.",
    "miLista.emptyJournalBody": "Marca un lugar como visitado y guarda el recuerdo.",
    "miLista.resultCount": "{count} resultados",
    "miLista.clearSearch": "Borrar búsqueda",
    "miLista.yourPlans": "Tus planes",
    "miLista.itinerary": "Itinerario",
    "miLista.collection": "Colección",
    "miLista.days": "días",
    "miLista.places": "lugares",
    "miLista.open": "Abrir",
    "miLista.planName": "Nombre del plan",
    "miLista.planNamePlaceholder": "Ej. Fin de semana en San Juan",
    "miLista.planType": "Tipo de plan",
    "miLista.typeCollection": "Colección simple",
    "miLista.typeItinerary": "Itinerario con días",
    "miLista.create": "Crear",
    "miLista.planDays": "Días",
    "miLista.noStops": "Todavía no hay paradas.",
    "miLista.addSavedPlace": "+ Añadir lugar guardado",
    "miLista.planDeviceNote": "Tu plan se guarda en este dispositivo. Comparte tu lista para enviar tus lugares guardados.",
    "miLista.removeStop": "Quitar parada",
    "miLista.day": "Día",
    "miLista.tripPlan": "Plan de viaje",
    "miLista.choosePlan": "¿Dónde lo pones?",
    "miLista.newCollection": "Nueva colección",
    "miLista.collections": "Colecciones",
    "miLista.pendingBook": "Por reservar",
    "miLista.linkVisited": "Enlace visitado",
    "miLista.confirmed": "Confirmada",
    "miLista.completed": "Completada",
    "miLista.cancelled": "Cancelada",
    "miLista.addBookingDetails": "Añadir detalles de la reserva",
    "miLista.bookingDetails": "Detalles de la reserva",
    "miLista.provider": "Proveedor",
    "miLista.date": "Fecha",
    "miLista.guests": "Personas",
    "miLista.reference": "Número de confirmación",
    "miLista.note": "Nota personal",
    "miLista.openProvider": "Abrir en el proveedor",
    "miLista.markCompleted": "Marcar completada",
    "miLista.cancelBooking": "Cancelar reserva",
    "miLista.userRecorded": "Añadida por ti",
    "miLista.bookingNote": "Las reservas se completan con el proveedor. Aquí solo llevas la cuenta.",
    "miLista.journalEntry": "Entrada del diario",
    "miLista.visitDate": "Fecha de la visita",
    "miLista.addToJournal": "Añadir al diario",
    "miLista.removeFromJournal": "Quitar del diario",
    "miLista.yourNote": "Tu nota",
    "miLista.noNote": "Sin nota",
    "beach.activities": "Qué puedes hacer aquí",
    "beach.bestFor": "Ideal para",
    "beach.water": "Agua",
    "beach.amenities": "Servicios",
    "beach.nearby": "Mientras estás aquí",
    "beach.compare": "Comparación rápida",
    "beach.compareSub": "Todas las playas lado a lado — desliza la tabla de lado en el teléfono.",
    "beach.col.beach": "Playa",
    "beach.col.area": "Área / Distrito",
    "beach.col.coords": "Coordenadas",
    "beach.col.bestFor": "Ideal para",
    "beach.col.water": "Condición del agua",
    "filter.title": "Búsqueda avanzada",
    "filter.lead": "Elige una categoría y luego el tipo de lugar dentro de ella. Después un barrio.",
    "filter.category": "Categoría",
    "filter.anyCategory": "Cualquier categoría",
    "filter.typeIn": "Tipo en {category}",
    "filter.allIn": "Todo {category}",
    "filter.neighborhood": "Barrio",
    "filter.allSanJuan": "Todo San Juan",
    "filter.reset": "Restablecer selección",
    "filter.hint":
      "El siguiente paso reduce la categoría a uno de sus tipos — de Chinchorros y Kioscos a Mariscos y Cafés y Café de Especialidad.",
    "notFound.place": "Lugar no encontrado",
    "notFound.placeBody": "Este enlace todavía no corresponde a ningún lugar en Ya Tú Sabes.",
    "notFound.browse": "Explorar lugares",
    "notFound.page": "Página no encontrada",
    "notFound.pageBody": "No encontramos \"{path}\" en Ya Tú Sabes. Puede que el enlace sea antiguo o tenga un error.",
    "notFound.pageBodyGeneric": "No encontramos esa página en Ya Tú Sabes. Puede que el enlace sea antiguo o tenga un error.",
    "notFound.home": "Volver al inicio",
    "notFound.adminNote": "Nota de admin: ninguna ruta ni negocio coincide con esta dirección.",
    "notFound.story": "Historia no encontrada",
    "detail.comingSoon": "Próximamente",
    "home.comingSoonIn": "Próximamente en {category}",
    "events.kicker": "Qué está pasando",
    "events.title": "Eventos",
    "events.lead": "Cosas que hacer en todo Puerto Rico — música en vivo, mercados, cultura y más.",
    "events.calendar": "Calendario",
    "events.calendarTitle": "Calendario de eventos",
    "events.calendarEmpty": "No hay nada en el calendario para esta fecha.",
    "services.claim": "Reclama este espacio →",
    "services.comingSoonBody":
      "Los servicios de la isla, todos en un solo lugar. Estas páginas están abiertas y esperando a quienes los dirigen — reclama la tuya y ponte en el mapa.",
  },
};